"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.LoanApplicationModal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var api_1 = require("@react-google-maps/api");
var firestore_1 = require("firebase/firestore");
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var firebase_file_upload_1 = require("../api/calls/docs/firebase_file_upload");
var application_1 = require("../api/calls/loan/application");
var get_firebase_user_profile_1 = require("../api/calls/user/get_firebase_user_profile");
var validation_messages_1 = require("../constants/validation-messages");
var auth_1 = require("../features/apis/auth");
var sites_1 = require("../features/apis/sites");
var auth_2 = require("../features/slices/auth");
var user_profile_1 = require("../features/slices/user-profile");
var content_dialog_1 = require("../features/thunks/content-dialog");
var useCurrency_1 = require("../hooks/useCurrency");
var hooks_1 = require("../store/hooks");
var loan_application_1 = require("../types/loan-application");
var currency_1 = require("../utils/currency");
var firebase_1 = require("../utils/firebase");
var loan_application_validators_1 = require("../utils/loan-application-validators");
var loan_data_mapper_1 = require("../utils/loan-data-mapper");
var phone_utils_1 = require("../utils/phone-utils");
var user_state_1 = require("../utils/user-state");
var loan_application_completed_1 = require("./loan-application-completed");
var loan_application_step_renderer_1 = require("./loan-application-step-renderer");
var step_constants_1 = require("./steps/step-constants");
// Google Maps libraries configuration
var libraries = ["places"];
// Loan amount configuration constants - will be replaced with dynamic values
// Step constants imported from ./steps/step-constants.ts (12-step Sky Lifestyle Web flow)
// Removed 6-step collapsed constants - now using proper 12-step architecture
// TODO Phase 3: Remove these temporary aliases after migrating to step renderer
// These map the old 6-step collapsed constants to their 12-step equivalents
var STEP_PERSONAL = step_constants_1.STEP_PERSONAL_DETAILS; // Maps to step 2
var STEP_LOAN_AFFORDABILITY = step_constants_1.STEP_FINANCIAL_DETAILS; // Maps to step 7 (loan setup is now STEP_START)
var STEP_EMPLOYMENT_PAYPOINT = step_constants_1.STEP_EMPLOYMENT; // Maps to step 4 (will split into 4,5,6)
var STEP_BANKING_DOCUMENTS = step_constants_1.STEP_DOCUMENTS; // Maps to step 8 (will split into 8,9)
var STEP_AGREEMENTS = step_constants_1.STEP_AUTHORIZATION_ELECTRONIC; // Maps to step 10
var GENDERS = [
    { value: "Male", label: "Male" },
    { value: "Female", label: "Female" },
];
var MARRIAGE_TYPES = [
    { value: "InCommunityOfProperty", label: "In Community Of Property" },
    { value: "OutOfCommunityOfProperty", label: "Out Of Community Of Property" },
    { value: "Traditional", label: "Traditional" },
];
// Some older user profiles persist abbreviated marriage_type strings ("Out of
// C.O.P", "In C.O.P") that pre-date the MARRIAGE_TYPES enum above. MUI Select
// can't match those to an option and renders blank. Normalise on read so the
// Select always receives a canonical value; the write path in this modal
// already produces canonical values, so existing records get self-healed on
// the next save without a migration.
var LEGACY_MARRIAGE_TYPE_MAP = {
    "In C.O.P": "InCommunityOfProperty",
    "In C.O.P.": "InCommunityOfProperty",
    "Out of C.O.P": "OutOfCommunityOfProperty",
    "Out of C.O.P.": "OutOfCommunityOfProperty",
    in_community_of_property: "InCommunityOfProperty",
    out_of_community_of_property: "OutOfCommunityOfProperty",
};
var normalizeMarriageType = function (raw) {
    var _a;
    if (!raw)
        return "";
    return (_a = LEGACY_MARRIAGE_TYPE_MAP[raw]) !== null && _a !== void 0 ? _a : raw;
};
// Loan terms imported from types - single source of truth
var LOAN_TERMS = loan_application_1.LOAN_TERMS_OPTIONS;
// BRANCHES now loaded dynamically from Firebase
var EMPLOYMENT_STATUSES = [
    { value: "permanent", label: "Permanent Employee" },
    { value: "contract", label: "Contract Employee" },
    { value: "temporary", label: "Temporary Employee" },
    { value: "self_employed", label: "Self Employed" },
    { value: "unemployed", label: "Unemployed" },
    { value: "retired", label: "Retired" },
];
/**
 * Salary deduction applies only to employed applicants whose employer can
 * process the deduction. Normalising once keeps validation and rendering in
 * sync for both legacy title-case values and the current lowercase values.
 */
var employmentRequiresSalaryDeduction = function (status) {
    var normalizedStatus = status.trim().toLowerCase();
    return (normalizedStatus === "permanent" ||
        normalizedStatus === "contract" ||
        normalizedStatus === "temporary");
};
var PAY_FREQUENCIES = [
    { value: "monthly", label: "Monthly" },
    { value: "weekly", label: "Weekly" },
    { value: "bi_weekly", label: "Bi-Weekly" },
    { value: "daily", label: "Daily" },
];
// Bank values must match Sky Lifestyle Web exactly for data prepopulation
var BANKS = [
    { value: "First National Bank", label: "First National Bank" },
    { value: "Standard Bank", label: "Standard Bank" },
    { value: "Nedbank", label: "Nedbank" },
    { value: "Bank Windhoek", label: "Bank Windhoek" },
    { value: "Letshego Bank Namibia", label: "Letshego Bank Namibia" },
    { value: "Trutsco Bank", label: "Trutsco Bank" },
    { value: "Banco Atlantico", label: "Banco Atlantico" },
    { value: "Bank BIC Namibia", label: "Bank BIC Namibia" },
];
// Account type values must match Sky Lifestyle Web exactly for data prepopulation
var ACCOUNT_TYPES = [
    { value: "Savings", label: "Savings Account" },
    { value: "Cheque", label: "Cheque Account" },
];
// Map steps to their completion flag names in Firestore
// Used for clearing flags when user navigates backwards
var STEP_COMPLETION_FLAGS = (_a = {},
    _a[step_constants_1.STEP_START] = null, // No completion flag for start step
    _a[step_constants_1.STEP_KYC] = null, // KYC completion is permanent - never cleared
    _a[step_constants_1.STEP_PERSONAL_DETAILS] = "personal_complete",
    _a[step_constants_1.STEP_FAMILY_CONTACTS] = "family_complete", // Note: also has friend_complete
    _a[step_constants_1.STEP_EMPLOYMENT] = "employment_complete",
    _a[step_constants_1.STEP_HR_DETAILS] = "paypoint_complete",
    _a[step_constants_1.STEP_SALARY_BANKING] = "bankDetails_complete",
    _a[step_constants_1.STEP_FINANCIAL_DETAILS] = "financial_complete",
    _a[step_constants_1.STEP_DOCUMENTS] = "docs_complete",
    _a[step_constants_1.STEP_AUTHORIZATION_SALARY] = "authoriseSalary_complete",
    _a[step_constants_1.STEP_AUTHORIZATION_ELECTRONIC] = "authoriseBank_complete",
    _a[step_constants_1.STEP_COMPLETE] = null,
    _a);
var LoanApplicationModal = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z;
    var isOpen = _a.isOpen, onClose = _a.onClose, branding = _a.branding, siteName = _a.siteName, siteConfig = _a.siteConfig, loanConfig = _a.loanConfig, initialAmount = _a.initialAmount, // Amount selected from home screen
    currentLoan = _a.currentLoan, // Loan to continue if applicable
    _0 = _a.forceNewApplication, // Loan to continue if applicable
    forceNewApplication = _0 === void 0 ? false : _0;
    var currency = (0, useCurrency_1.useCurrency)(siteConfig).currency;
    var dispatch = (0, hooks_1.useAppDispatch)();
    var _1 = (0, react_1.useState)(step_constants_1.STEP_START), currentStepInternal = _1[0], setCurrentStepInternal = _1[1];
    var auth = (0, react_redux_1.useSelector)(function (state) { return state.auth; });
    // DEBUG: Wrap setCurrentStep to trace all calls
    var setCurrentStep = function (newStep) {
        setCurrentStepInternal(newStep);
    };
    var currentStep = currentStepInternal;
    // Dynamic loan amount limits from configuration
    var LOAN_AMOUNT_LIMITS = {
        MIN: (loanConfig === null || loanConfig === void 0 ? void 0 : loanConfig.minAmount) || 500,
        MAX: (loanConfig === null || loanConfig === void 0 ? void 0 : loanConfig.maxAmount) || 150000,
        DEFAULT: (loanConfig === null || loanConfig === void 0 ? void 0 : loanConfig.defaultAmount) || 500,
    };
    var user = (0, react_redux_1.useSelector)(function (state) { return state.auth; });
    var firebaseUserProfile = (0, react_redux_1.useSelector)(function (state) {
        return state.userProfile.profile;
    });
    // Profile API hooks
    var _2 = (0, auth_1.useGetProfileQuery)(undefined, {
        skip: !(user === null || user === void 0 ? void 0 : user.firebase_user_id), // Only fetch profile if Firebase user is logged in
    }), profileData = _2.data, isProfileLoading = _2.isLoading;
    var updateProfile = (0, auth_1.useUpdateProfileMutation)()[0];
    var removeUndefinedDeep = function (value) {
        if (value instanceof firestore_1.Timestamp) {
            return value;
        }
        // Preserve Date objects (used for appointment_date, date_updated, etc.)
        // Date objects have typeof "object" but Object.keys returns [], which
        // would cause them to be incorrectly stripped as "empty objects"
        if (value instanceof Date) {
            return value;
        }
        if (value instanceof firestore_1.GeoPoint) {
            return value;
        }
        if (Array.isArray(value)) {
            var cleanedArray = value
                .map(removeUndefinedDeep)
                .filter(function (item) { return item !== undefined; });
            return cleanedArray.length > 0 ? cleanedArray : undefined;
        }
        if (value && typeof value === "object") {
            var result_1 = {};
            Object.keys(value).forEach(function (key) {
                var cleaned = removeUndefinedDeep(value[key]);
                if (cleaned !== undefined) {
                    result_1[key] = cleaned;
                }
            });
            return Object.keys(result_1).length > 0 ? result_1 : undefined;
        }
        return value !== undefined ? value : undefined;
    };
    // Load Google Maps with Places library
    var _3 = (0, api_1.useJsApiLoader)({
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
        libraries: libraries,
    }), isGoogleMapsLoadedRaw = _3.isLoaded, loadError = _3.loadError;
    // Treat Maps as loaded even if there's an error - Places autocomplete can work independently
    // This allows the application to proceed even if Maps JavaScript API is not enabled
    var isGoogleMapsLoaded = isGoogleMapsLoadedRaw || !!loadError;
    (0, react_1.useEffect)(function () {
        if (loadError) {
            console.warn("⚠️ Google Maps load error (address autocomplete may still work):", loadError.message);
        }
    }, [loadError]);
    // Update loan amount when initialAmount changes (from home screen selection)
    (0, react_1.useEffect)(function () {
        if (isOpen && initialAmount && remoteDraftLoadedRef.current === false) {
            setLoanAmount(initialAmount.toFixed(2));
        }
    }, [isOpen, initialAmount]);
    // Check KYC status and skip to next step if already approved
    // Triggers when: step changes to STEP_KYC or verification status changes
    (0, react_1.useEffect)(function () {
        if (currentStep === step_constants_1.STEP_KYC) {
            var isSumSubApproved = (0, user_state_1.isKycVerified)(user, firebaseUserProfile);
            var hasPersonalInfo = !!firebaseUserProfile &&
                firebaseUserProfile.name &&
                firebaseUserProfile.surname &&
                firebaseUserProfile.id_number;
            if (isSumSubApproved && hasPersonalInfo) {
                setKycCompleted(true);
                // Only auto-skip if user is NOT manually navigating backwards
                if (!isManualNavigationRef.current) {
                    // Use setTimeout to ensure state is updated after render
                    setTimeout(function () {
                        setCurrentStep(step_constants_1.STEP_PERSONAL_DETAILS);
                    }, 0);
                }
            }
            else if (isSumSubApproved && !hasPersonalInfo) {
                // There appears to be an inconsistency - clear SumSubApproved flags to force re-verification
                dispatch((0, user_profile_1.setFirebaseUserProfile)(__assign(__assign({}, firebaseUserProfile), { SumSubApproved: false })));
                dispatch((0, auth_2.clearKYCApproval)());
                setKycCompleted(false);
            }
            else {
                setKycCompleted(false);
            }
        }
    }, [currentStep, firebaseUserProfile, user.SumSubApproved, dispatch]);
    // KYC Enforcement: Redirect to KYC step if verification is incomplete/reset
    (0, react_1.useEffect)(function () {
        var isSumSubApproved = (0, user_state_1.isKycVerified)(user, firebaseUserProfile);
        // If user is past KYC step but KYC is not approved, force them back to KYC
        if (currentStep > step_constants_1.STEP_KYC && !isSumSubApproved) {
            setCurrentStep(step_constants_1.STEP_KYC);
            setKycCompleted(false);
        }
    }, [currentStep, user.SumSubApproved, firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.SumSubApproved]);
    // Personal Information State
    var _4 = (0, react_1.useState)((firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.name) || ""), name = _4[0], setName = _4[1];
    var _5 = (0, react_1.useState)((firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.surname) || ""), surname = _5[0], setSurname = _5[1];
    var _6 = (0, react_1.useState)((firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.id_number) || ""), idNumber = _6[0], setIdNumber = _6[1];
    var _7 = (0, react_1.useState)(firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.home_address), homeAddress = _7[0], setHomeAddress = _7[1];
    var _8 = (0, react_1.useState)(((_b = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.home_address) === null || _b === void 0 ? void 0 : _b.location) || null), homeAddressGeoPoint = _8[0], setHomeAddressGeoPoint = _8[1];
    var _9 = (0, react_1.useState)(((_c = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.home_address) === null || _c === void 0 ? void 0 : _c.homeErf) || ""), homeErf = _9[0], setHomeErf = _9[1];
    var _10 = (0, react_1.useState)((firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.postal_address) || ""), postalAddress = _10[0], setPostalAddress = _10[1];
    var _11 = (0, react_1.useState)(null), postalAddressGeoPoint = _11[0], setPostalAddressGeoPoint = _11[1];
    var _12 = (0, react_1.useState)((firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.gender) || ""), gender = _12[0], setGender = _12[1];
    // Marriage Status State
    var _13 = (0, react_1.useState)(function () {
        // Default to false when no value exists in the Firebase record
        if (typeof (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.is_married) === "boolean") {
            return firebaseUserProfile.is_married;
        }
        return false;
    }), isMarried = _13[0], setIsMarried = _13[1];
    var _14 = (0, react_1.useState)(normalizeMarriageType(firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.marriage_type)), marriageType = _14[0], setMarriageType = _14[1];
    // Spouse Details State
    var _15 = (0, react_1.useState)(""), spouseName = _15[0], setSpouseName = _15[1];
    var _16 = (0, react_1.useState)(""), spouseLastName = _16[0], setSpouseLastName = _16[1];
    // Initialize spouse phone numbers with safe defaults
    // These will be populated from Firebase in the useEffect at line 3142
    var _17 = (0, react_1.useState)({
        phone_number: "",
        country_code: "+264",
        country_abbreviation: "NA",
    }), spousePhoneNumber = _17[0], setSpousePhoneNumber = _17[1];
    var _18 = (0, react_1.useState)({
        phone_number: "",
        country_code: "+264",
        country_abbreviation: "NA",
    }), spouseHomeNumber = _18[0], setSpouseHomeNumber = _18[1];
    var _19 = (0, react_1.useState)({
        phone_number: "",
        country_code: "+264",
        country_abbreviation: "NA",
    }), spouseWorkNumber = _19[0], setSpouseWorkNumber = _19[1];
    // Family Members and Friend Contact Details State
    // Family Member (only 1 required)
    // Initialize with safe defaults - will be populated from Firebase/loan data in useEffect
    var _20 = (0, react_1.useState)(""), familyMemberName = _20[0], setFamilyMemberName = _20[1];
    var _21 = (0, react_1.useState)(""), familyMemberSurname = _21[0], setFamilyMemberSurname = _21[1];
    var _22 = (0, react_1.useState)(""), familyMemberRelationship = _22[0], setFamilyMemberRelationship = _22[1];
    var _23 = (0, react_1.useState)({
        phone_number: "",
        country_code: "+264",
        country_abbreviation: "NA",
    }), familyMemberCellPhone = _23[0], setFamilyMemberCellPhone = _23[1];
    var _24 = (0, react_1.useState)({
        phone_number: "",
        country_code: "+264",
        country_abbreviation: "NA",
    }), familyMemberWorkPhone = _24[0], setFamilyMemberWorkPhone = _24[1];
    var _25 = (0, react_1.useState)({
        phone_number: "",
        country_code: "+264",
        country_abbreviation: "NA",
    }), familyMemberHomePhone = _25[0], setFamilyMemberHomePhone = _25[1];
    // Friend Contact
    // Initialize with safe defaults - will be populated from Firebase/loan data in useEffect
    var _26 = (0, react_1.useState)(""), friendName = _26[0], setFriendName = _26[1];
    var _27 = (0, react_1.useState)(""), friendSurname = _27[0], setFriendSurname = _27[1];
    var _28 = (0, react_1.useState)({
        phone_number: "",
        country_code: "+264",
        country_abbreviation: "NA",
    }), friendCellPhone = _28[0], setFriendCellPhone = _28[1];
    var _29 = (0, react_1.useState)({
        phone_number: "",
        country_code: "+264",
        country_abbreviation: "NA",
    }), friendWorkPhone = _29[0], setFriendWorkPhone = _29[1];
    var _30 = (0, react_1.useState)({
        phone_number: "",
        country_code: "+264",
        country_abbreviation: "NA",
    }), friendHomePhone = _30[0], setFriendHomePhone = _30[1];
    // Next of Kin selection (only one can be selected)
    var _31 = (0, react_1.useState)(null), nextOfKin = _31[0], setNextOfKin = _31[1];
    // Step 2: Loan Amount & Employment State
    // Loan Details
    var _32 = (0, react_1.useState)(""), selectedBranch = _32[0], setSelectedBranch = _32[1];
    var _33 = (0, react_1.useState)(""), loanTerm = _33[0], setLoanTerm = _33[1];
    var _34 = (0, react_1.useState)(initialAmount
        ? initialAmount.toFixed(2) // Use amount from home screen if provided
        : LOAN_AMOUNT_LIMITS.DEFAULT.toFixed(2)), loanAmount = _34[0], setLoanAmount = _34[1];
    // Firebase data
    var _35 = (0, react_1.useState)(), provider = _35[0], setProvider = _35[1];
    var _36 = (0, react_1.useState)([]), branches = _36[0], setBranches = _36[1];
    var _37 = (0, react_1.useState)(false), loadingProviders = _37[0], setLoadingProviders = _37[1];
    var _38 = (0, react_1.useState)(false), loadingBranches = _38[0], setLoadingBranches = _38[1];
    var _39 = (0, react_1.useState)(""), selectedProviderId = _39[0], setSelectedProviderId = _39[1];
    // Employment Status — initial value from profile; re-seeded after Redux
    // load by the consolidated prefill useEffect below if Redux hadn't loaded yet.
    var _40 = (0, react_1.useState)(((_d = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.employment_details) === null || _d === void 0 ? void 0 : _d.employment_status) || ""), employmentStatus = _40[0], setEmploymentStatus = _40[1];
    var _41 = (0, react_1.useState)(((_e = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.employment_details) === null || _e === void 0 ? void 0 : _e.monthly_income) || ""), monthlyIncome = _41[0], setMonthlyIncome = _41[1];
    // Employment Details
    var _42 = (0, react_1.useState)(((_f = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.employment_details) === null || _f === void 0 ? void 0 : _f.employer) || ""), employer = _42[0], setEmployer = _42[1];
    var _43 = (0, react_1.useState)(((_g = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.employment_details) === null || _g === void 0 ? void 0 : _g.supervisor) || ""), supervisorName = _43[0], setSupervisorName = _43[1];
    var _44 = (0, react_1.useState)({
        phone_number: ((_j = (_h = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.employment_details) === null || _h === void 0 ? void 0 : _h.work_number) === null || _j === void 0 ? void 0 : _j.phone_number) || "",
        country_code: ((_l = (_k = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.employment_details) === null || _k === void 0 ? void 0 : _k.work_number) === null || _l === void 0 ? void 0 : _l.country_code) ||
            "+264",
        country_abbreviation: (((_o = (_m = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.employment_details) === null || _m === void 0 ? void 0 : _m.work_number) === null || _o === void 0 ? void 0 : _o.country_abbreviation) || "NA"),
    }), workNumber = _44[0], setWorkNumber = _44[1];
    var _45 = (0, react_1.useState)(((_p = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.employment_details) === null || _p === void 0 ? void 0 : _p.department) || ""), departmentNumber = _45[0], setDepartmentNumber = _45[1];
    var _46 = (0, react_1.useState)(((_q = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.employment_details) === null || _q === void 0 ? void 0 : _q.address) || ""), workplaceAddress = _46[0], setWorkplaceAddress = _46[1];
    var _47 = (0, react_1.useState)(null), workplaceAddressGeoPoint = _47[0], setWorkplaceAddressGeoPoint = _47[1];
    var _48 = (0, react_1.useState)(((_r = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.employment_details) === null || _r === void 0 ? void 0 : _r.employee_number) || ""), employeeNumber = _48[0], setEmployeeNumber = _48[1];
    var _49 = (0, react_1.useState)(function () {
        var _a;
        var date = (_a = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.employment_details) === null || _a === void 0 ? void 0 : _a.appointment_date;
        if (!date)
            return "";
        // Handle string (already in correct format)
        if (typeof date === "string")
            return date.split("T")[0];
        // Handle Date object
        if (date instanceof Date)
            return date.toISOString().split("T")[0];
        // Handle Timestamp object (has toDate method)
        if (typeof date === "object" && "toDate" in date) {
            return date.toDate().toISOString().split("T")[0];
        }
        return "";
    }), appointmentDate = _49[0], setAppointmentDate = _49[1];
    // Authorization for Salary Deduction
    var _50 = (0, react_1.useState)(((_s = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.financial_detail) === null || _s === void 0 ? void 0 : _s.payment_frequency) || ""), payFrequency = _50[0], setPayFrequency = _50[1];
    var _51 = (0, react_1.useState)(((_t = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.financial_detail) === null || _t === void 0 ? void 0 : _t.preferred_payday) || ""), payDate = _51[0], setPayDate = _51[1];
    var _52 = (0, react_1.useState)((firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.name) || ""), employeeName = _52[0], setEmployeeName = _52[1];
    var _53 = (0, react_1.useState)((firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.surname) || ""), employeeSurname = _53[0], setEmployeeSurname = _53[1];
    var _54 = (0, react_1.useState)((firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.id_number) || ""), employeeIdNumber = _54[0], setEmployeeIdNumber = _54[1];
    // Initialize with safe defaults - will be populated from Firebase in useEffect
    var _55 = (0, react_1.useState)({
        phone_number: "",
        country_code: "+264",
        country_abbreviation: "NA",
    }), employeePhoneNumber = _55[0], setEmployeePhoneNumber = _55[1];
    var _56 = (0, react_1.useState)(""), forceNumber = _56[0], setForceNumber = _56[1];
    var _57 = (0, react_1.useState)(""), lender = _57[0], setLender = _57[1];
    var _58 = (0, react_1.useState)(((_u = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.employment_details) === null || _u === void 0 ? void 0 : _u.employer) || ""), yourEmployer = _58[0], setYourEmployer = _58[1];
    // Track manual edits so yourEmployer stays in sync with Employment step when untouched.
    var _59 = (0, react_1.useState)(false), hasEditedYourEmployer = _59[0], setHasEditedYourEmployer = _59[1];
    var _60 = (0, react_1.useState)(""), signedDocumentUrl = _60[0], setSignedDocumentUrl = _60[1];
    // Signature-related state (Salary Deduction)
    var signatureRef = (0, react_1.useRef)(null);
    var _61 = (0, react_1.useState)(""), signatureURL = _61[0], setSignatureURL = _61[1];
    var _62 = (0, react_1.useState)(""), signatureError = _62[0], setSignatureError = _62[1];
    var _63 = (0, react_1.useState)(false), isSavingSignature = _63[0], setIsSavingSignature = _63[1];
    // Bank Debit Authorization Signature state
    var bankSignatureRef = (0, react_1.useRef)(null);
    var _64 = (0, react_1.useState)(""), bankSignatureURL = _64[0], setBankSignatureURL = _64[1];
    var _65 = (0, react_1.useState)(""), bankSignatureError = _65[0], setBankSignatureError = _65[1];
    var _66 = (0, react_1.useState)(false), isSavingBankSignature = _66[0], setIsSavingBankSignature = _66[1];
    var remoteDraftLoadedRef = (0, react_1.useRef)(false);
    // Keep the last loaded draft available so a later profile refresh can replay
    // the same draft-over-profile merge instead of overwriting draft fields.
    var loadedDraftForProfileReplayRef = (0, react_1.useRef)(null);
    var hasResumedStepRef = (0, react_1.useRef)(false); // Track if we've already auto-resumed to prevent overriding manual navigation
    var isManualNavigationRef = (0, react_1.useRef)(false); // Track if user is manually navigating (back button)
    var hasPrefilledFromProfileRef = (0, react_1.useRef)(false);
    var hasPrefilledFromFirebaseRef = (0, react_1.useRef)(false);
    var isSubmittingRef = (0, react_1.useRef)(false);
    var pendingResetRef = (0, react_1.useRef)(false);
    var currentApplicationIdRef = (0, react_1.useRef)(null);
    // Step 3: Affordability State
    // Monthly Expenses
    var _67 = (0, react_1.useState)("0.00"), housingExpense = _67[0], setHousingExpense = _67[1];
    var _68 = (0, react_1.useState)("0.00"), transportExpense = _68[0], setTransportExpense = _68[1];
    var _69 = (0, react_1.useState)("0.00"), educationExpense = _69[0], setEducationExpense = _69[1];
    var _70 = (0, react_1.useState)("0.00"), electricityExpense = _70[0], setElectricityExpense = _70[1];
    var _71 = (0, react_1.useState)("0.00"), groceriesExpense = _71[0], setGroceriesExpense = _71[1];
    var _72 = (0, react_1.useState)({
        housing: true,
        transport: true,
        education: true,
        electricity: true,
        groceries: true,
    }), visibleExpenses = _72[0], setVisibleExpenses = _72[1];
    // Account Payments (dynamic)
    var _73 = (0, react_1.useState)([{ id: "1", description: "Clothing", amount: "0.00" }]), accountPayments = _73[0], setAccountPayments = _73[1];
    // Fixed Monthly Deductions (dynamic)
    var _74 = (0, react_1.useState)([{ id: "1", description: "Debit Orders etc..", amount: "0.00" }]), fixedDeductions = _74[0], setFixedDeductions = _74[1];
    // Other Financial Obligations (dynamic)
    var _75 = (0, react_1.useState)([{ id: "1", description: "Food", amount: "0.00" }]), otherObligations = _75[0], setOtherObligations = _75[1];
    // Step 4: Paypoint & Banking State
    // Pay point Details
    var _76 = (0, react_1.useState)(((_v = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.employment_details) === null || _v === void 0 ? void 0 : _v.employer) || ""), paymasterName = _76[0], setPaymasterName = _76[1];
    // Initialize with safe defaults - will be populated from Firebase in useEffect
    var _77 = (0, react_1.useState)({
        phone_number: "",
        country_code: "+264",
        country_abbreviation: "NA",
    }), payPointPhoneNumber = _77[0], setPayPointPhoneNumber = _77[1];
    // HR Phone Number - initialized from paypoint_details.phone_number
    // (Sky Web stores HR phone as phone_number in paypoint_details)
    var _78 = (0, react_1.useState)(function () {
        var _a;
        var phone = (_a = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.paypoint_details) === null || _a === void 0 ? void 0 : _a.phone_number;
        if (phone === null || phone === void 0 ? void 0 : phone.phone_number) {
            return {
                phone_number: phone.phone_number,
                country_code: phone.country_code || "+264",
                country_abbreviation: (phone.country_abbreviation ||
                    "NA"),
            };
        }
        return {
            phone_number: "",
            country_code: "+264",
            country_abbreviation: "NA",
        };
    }), hrPhoneNumber = _78[0], setHRPhoneNumber = _78[1];
    // HR Name - initialized from paypoint_details.paymaster_number
    // (Sky Web stores HR Name as paymaster_number in paypoint_details)
    var _79 = (0, react_1.useState)(((_w = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.paypoint_details) === null || _w === void 0 ? void 0 : _w.paymaster_number) || ""), hrName = _79[0], setHRName = _79[1];
    var _80 = (0, react_1.useState)(((_x = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.paypoint_details) === null || _x === void 0 ? void 0 : _x.postal_address) || ""), payPointPostalAddress = _80[0], setPayPointPostalAddress = _80[1];
    var _81 = (0, react_1.useState)(null), payPointPostalAddressGeoPoint = _81[0], setPayPointPostalAddressGeoPoint = _81[1];
    var _82 = (0, react_1.useState)(((_y = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.paypoint_details) === null || _y === void 0 ? void 0 : _y.postal_code) || ""), postalCode = _82[0], setPostalCode = _82[1];
    var _83 = (0, react_1.useState)(((_z = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.paypoint_details) === null || _z === void 0 ? void 0 : _z.physical_address) || ""), payPointPhysicalAddress = _83[0], setPayPointPhysicalAddress = _83[1];
    var _84 = (0, react_1.useState)(null), payPointPhysicalAddressGeoPoint = _84[0], setPayPointPhysicalAddressGeoPoint = _84[1];
    // Salary Banking Details
    var _85 = (0, react_1.useState)(""), selectedBank = _85[0], setSelectedBank = _85[1];
    var _86 = (0, react_1.useState)(""), bankBranch = _86[0], setBankBranch = _86[1];
    var _87 = (0, react_1.useState)(""), accountNumber = _87[0], setAccountNumber = _87[1];
    var _88 = (0, react_1.useState)(""), accountType = _88[0], setAccountType = _88[1];
    // Document uploads
    var _89 = (0, react_1.useState)(null), salaryBankingDoc1 = _89[0], setSalaryBankingDoc1 = _89[1];
    var _90 = (0, react_1.useState)([]), salaryBankingDoc2 = _90[0], setSalaryBankingDoc2 = _90[1];
    var _91 = (0, react_1.useState)(""), latestPayslipUrl = _91[0], setLatestPayslipUrl = _91[1];
    var _92 = (0, react_1.useState)([]), bankStatementsUrl = _92[0], setBankStatementsUrl = _92[1];
    // Step 0: KYC State
    var _93 = (0, react_1.useState)(false), kycCompleted = _93[0], setKycCompleted = _93[1];
    var _94 = (0, react_1.useState)(null), kycError = _94[0], setKycError = _94[1];
    // Step 5: Review State
    var _95 = (0, react_1.useState)(false), confirmationChecked = _95[0], setConfirmationChecked = _95[1];
    // Completion State
    var _96 = (0, react_1.useState)(false), showCompletionModal = _96[0], setShowCompletionModal = _96[1];
    // Application tracking state
    var _97 = (0, react_1.useState)(null), currentApplicationId = _97[0], setCurrentApplicationId = _97[1];
    var _98 = (0, react_1.useState)(false), isSubmitting = _98[0], setIsSubmitting = _98[1];
    var _99 = (0, react_1.useState)(false), isCheckingDraft = _99[0], setIsCheckingDraft = _99[1];
    // Error states
    var _100 = (0, react_1.useState)({}), errors = _100[0], setErrors = _100[1];
    var _101 = (0, react_1.useState)(""), validationMessage = _101[0], setValidationMessage = _101[1];
    var monthlyExpenseOrder = [
        "housing",
        "transport",
        "education",
        "electricity",
        "groceries",
    ];
    var monthlyExpenseErrorKeys = {
        housing: "housingExpense",
        transport: "transportExpense",
        education: "educationExpense",
        electricity: "electricityExpense",
        groceries: "groceriesExpense",
    };
    var monthlyExpenseConfig = {
        housing: {
            label: "Housing",
            value: housingExpense,
            setter: setHousingExpense,
        },
        transport: {
            label: "Transport",
            value: transportExpense,
            setter: setTransportExpense,
        },
        education: {
            label: "Education",
            value: educationExpense,
            setter: setEducationExpense,
        },
        electricity: {
            label: "Electricity",
            value: electricityExpense,
            setter: setElectricityExpense,
        },
        groceries: {
            label: "Groceries and other expenses",
            value: groceriesExpense,
            setter: setGroceriesExpense,
            wrapperClass: "md:col-span-2",
        },
    };
    var handleHideMonthlyExpense = function (key) {
        var config = monthlyExpenseConfig[key];
        if (config) {
            config.setter("0.00");
        }
        setVisibleExpenses(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = false, _a)));
        });
        setErrors(function (prev) {
            var errorKey = monthlyExpenseErrorKeys[key];
            if (!prev[errorKey]) {
                return prev;
            }
            var updated = __assign({}, prev);
            delete updated[errorKey];
            return updated;
        });
    };
    var handleShowMonthlyExpense = function (key) {
        setVisibleExpenses(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = true, _a)));
        });
    };
    var hiddenMonthlyExpenses = monthlyExpenseOrder.filter(function (key) { return !visibleExpenses[key]; });
    var normalizePhoneForState = function (phone) {
        // Validate country_abbreviation is a 2-letter code, not a calling code
        var countryAbbreviation = phone === null || phone === void 0 ? void 0 : phone.country_abbreviation;
        if (!countryAbbreviation ||
            typeof countryAbbreviation !== "string" ||
            countryAbbreviation.length !== 2 ||
            countryAbbreviation.indexOf("+") !== -1 ||
            /\d/.test(countryAbbreviation) // Check if contains digits
        ) {
            countryAbbreviation = "NA";
        }
        return {
            phone_number: (0, phone_utils_1.enforcePhoneNumberLength)((phone === null || phone === void 0 ? void 0 : phone.phone_number) || "", countryAbbreviation),
            country_code: (phone === null || phone === void 0 ? void 0 : phone.country_code) || "+264",
            country_abbreviation: countryAbbreviation,
        };
    };
    var convertProfilePhoneToIPhone = function (phone) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (!phone)
            return undefined;
        var rawNumber = (_d = (_c = (_b = (_a = phone.phone_number) !== null && _a !== void 0 ? _a : phone.number) !== null && _b !== void 0 ? _b : phone.cell_number) !== null && _c !== void 0 ? _c : phone.cellPhone) !== null && _d !== void 0 ? _d : "";
        var callingCode = (_h = (_g = (_f = (_e = phone.country_code) !== null && _e !== void 0 ? _e : phone.calling_code) !== null && _f !== void 0 ? _f : phone.callingCode) !== null && _g !== void 0 ? _g : phone.code) !== null && _h !== void 0 ? _h : "+264";
        // Only use country_abbreviation or countryCode if it's a 2-letter code
        // Don't use country_code here as it's the calling code (+264), not abbreviation (NA)
        var countryAbbreviation = (_j = phone.country_abbreviation) !== null && _j !== void 0 ? _j : phone.countryCode;
        // Validate it's a 2-letter code, otherwise default to NA
        if (!countryAbbreviation ||
            countryAbbreviation.length !== 2 ||
            countryAbbreviation.indexOf("+") !== -1) {
            countryAbbreviation = "NA";
        }
        if (!rawNumber)
            return undefined;
        return normalizePhoneForState({
            phone_number: rawNumber,
            country_code: callingCode,
            country_abbreviation: countryAbbreviation,
        });
    };
    var determineStepFromLoan = function (loan) {
        if (!loan)
            return STEP_PERSONAL;
        if (!(loan === null || loan === void 0 ? void 0 : loan.personal_complete))
            return STEP_PERSONAL;
        if (!(loan === null || loan === void 0 ? void 0 : loan.financial_complete))
            return STEP_LOAN_AFFORDABILITY;
        if (!(loan === null || loan === void 0 ? void 0 : loan.employment_complete) ||
            !(loan === null || loan === void 0 ? void 0 : loan.paypoint_complete) ||
            !(loan === null || loan === void 0 ? void 0 : loan.bankDetails_complete)) {
            return STEP_EMPLOYMENT_PAYPOINT;
        }
        if (!(loan === null || loan === void 0 ? void 0 : loan.docs_complete))
            return STEP_BANKING_DOCUMENTS;
        if (!(loan === null || loan === void 0 ? void 0 : loan.authoriseSalary_complete) ||
            !(loan === null || loan === void 0 ? void 0 : loan.authoriseBank_complete) ||
            !(loan === null || loan === void 0 ? void 0 : loan.agree_terms)) {
            return STEP_AGREEMENTS;
        }
        return STEP_AGREEMENTS;
    };
    var applyMappedLoanData = (0, react_1.useCallback)(function (loan) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5;
        if (!loan)
            return;
        var getRefId = function (ref) {
            return ref && typeof ref === "object" && "id" in ref ? ref.id : "";
        };
        var setStringIfPresent = function (value, setter, transform) {
            if (transform === void 0) { transform = function (val) { return val; }; }
            if (typeof value === "string" && value.trim()) {
                setter(transform(value));
            }
        };
        var setPhoneIfPresent = function (phone, setter) {
            var normalized = convertProfilePhoneToIPhone(phone);
            if (normalized) {
                setter(normalizePhoneForState(normalized));
            }
        };
        // Always ensure primary personal details align with the Firebase profile
        if (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.name) {
            setName(firebaseUserProfile.name);
            setEmployeeName(firebaseUserProfile.name);
        }
        if (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.surname) {
            setSurname(firebaseUserProfile.surname);
            setEmployeeSurname(firebaseUserProfile.surname);
        }
        if (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.id_number) {
            setIdNumber(firebaseUserProfile.id_number);
            setEmployeeIdNumber(firebaseUserProfile.id_number);
        }
        if (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.gender) {
            setGender(firebaseUserProfile.gender);
        }
        if ((firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.is_married) !== undefined) {
            setIsMarried(firebaseUserProfile.is_married);
        }
        if (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.marriage_type) {
            setMarriageType(normalizeMarriageType(firebaseUserProfile.marriage_type));
        }
        if (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.home_address) {
            setHomeAddress(firebaseUserProfile.home_address);
            setHomeErf(firebaseUserProfile.home_address.homeErf || "");
            setHomeAddressGeoPoint(firebaseUserProfile.home_address.location || null);
        }
        if (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.postal_address) {
            setPostalAddress(firebaseUserProfile.postal_address);
        }
        // Personal information
        var extractFullAddress = function (value) {
            if (!value)
                return undefined;
            if (typeof value === "string")
                return value;
            if (typeof value === "object") {
                return (value.full_address ||
                    value.fullAddress ||
                    value.address ||
                    value.value ||
                    undefined);
            }
            return undefined;
        };
        if (loan.home_address) {
            var fullAddress_1 = extractFullAddress(loan.home_address.full_address) ||
                extractFullAddress((_a = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.home_address) === null || _a === void 0 ? void 0 : _a.full_address);
            setHomeAddress(function (prev) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
                return ({
                    full_address: (_c = (_a = fullAddress_1 !== null && fullAddress_1 !== void 0 ? fullAddress_1 : prev === null || prev === void 0 ? void 0 : prev.full_address) !== null && _a !== void 0 ? _a : (_b = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.home_address) === null || _b === void 0 ? void 0 : _b.full_address) !== null && _c !== void 0 ? _c : "",
                    homeErf: (_f = (_e = (_d = loan.home_address) === null || _d === void 0 ? void 0 : _d.homeErf) !== null && _e !== void 0 ? _e : prev === null || prev === void 0 ? void 0 : prev.homeErf) !== null && _f !== void 0 ? _f : (_g = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.home_address) === null || _g === void 0 ? void 0 : _g.homeErf,
                    location: (_m = (_k = (_j = (_h = loan.home_address) === null || _h === void 0 ? void 0 : _h.location) !== null && _j !== void 0 ? _j : prev === null || prev === void 0 ? void 0 : prev.location) !== null && _k !== void 0 ? _k : (_l = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.home_address) === null || _l === void 0 ? void 0 : _l.location) !== null && _m !== void 0 ? _m : null,
                });
            });
            setHomeErf((_e = (_c = (_b = loan.home_address) === null || _b === void 0 ? void 0 : _b.homeErf) !== null && _c !== void 0 ? _c : (_d = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.home_address) === null || _d === void 0 ? void 0 : _d.homeErf) !== null && _e !== void 0 ? _e : "");
            setHomeAddressGeoPoint(((_g = (_f = loan.home_address) === null || _f === void 0 ? void 0 : _f.location) !== null && _g !== void 0 ? _g : (_h = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.home_address) === null || _h === void 0 ? void 0 : _h.location) ||
                null);
        }
        setStringIfPresent(loan.postal_address, setPostalAddress);
        // Spouse details - prioritize loan data, fallback to Firebase profile
        var spouseNameValue = (_k = (_j = loan.spouse) === null || _j === void 0 ? void 0 : _j.name) !== null && _k !== void 0 ? _k : (_l = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.spouse) === null || _l === void 0 ? void 0 : _l.name;
        var spouseSurnameValue = (_o = (_m = loan.spouse) === null || _m === void 0 ? void 0 : _m.surname) !== null && _o !== void 0 ? _o : (_p = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.spouse) === null || _p === void 0 ? void 0 : _p.surname;
        setStringIfPresent(spouseNameValue, setSpouseName);
        setStringIfPresent(spouseSurnameValue, setSpouseLastName);
        // Phone numbers - try loan first, then Firebase profile
        if ((_q = loan.spouse) === null || _q === void 0 ? void 0 : _q.cell_number) {
            setPhoneIfPresent(loan.spouse.cell_number, setSpousePhoneNumber);
        }
        else if ((_r = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.spouse) === null || _r === void 0 ? void 0 : _r.cell_number) {
            var spouseCell = convertProfilePhoneToIPhone(firebaseUserProfile.spouse.cell_number);
            if (spouseCell) {
                setSpousePhoneNumber(normalizePhoneForState(spouseCell));
            }
        }
        if ((_s = loan.spouse) === null || _s === void 0 ? void 0 : _s.home_number) {
            setPhoneIfPresent(loan.spouse.home_number, setSpouseHomeNumber);
        }
        else if ((_t = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.spouse) === null || _t === void 0 ? void 0 : _t.home_number) {
            var spouseHome = convertProfilePhoneToIPhone(firebaseUserProfile.spouse.home_number);
            if (spouseHome) {
                setSpouseHomeNumber(normalizePhoneForState(spouseHome));
            }
        }
        if ((_u = loan.spouse) === null || _u === void 0 ? void 0 : _u.work_number) {
            setPhoneIfPresent(loan.spouse.work_number, setSpouseWorkNumber);
        }
        else if ((_v = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.spouse) === null || _v === void 0 ? void 0 : _v.work_number) {
            var spouseWork = convertProfilePhoneToIPhone(firebaseUserProfile.spouse.work_number);
            if (spouseWork) {
                setSpouseWorkNumber(normalizePhoneForState(spouseWork));
            }
        }
        if (loan.spouse || (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.spouse)) {
            setIsMarried(function (prev) { return (typeof prev === "boolean" ? prev : true); });
        }
        // Family member - load from loan, fallback to user profile
        if (loan.family_member) {
            setStringIfPresent(loan.family_member.name, setFamilyMemberName);
            setStringIfPresent(loan.family_member.surname, setFamilyMemberSurname);
            setStringIfPresent(loan.family_member.relationship, setFamilyMemberRelationship);
            setPhoneIfPresent(loan.family_member.cell_number, setFamilyMemberCellPhone);
            setPhoneIfPresent(loan.family_member.home_number, setFamilyMemberHomePhone);
            setPhoneIfPresent(loan.family_member.work_number, setFamilyMemberWorkPhone);
        }
        else if (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.family_member) {
            // Fallback to user profile if not in loan
            setFamilyMemberName((_w = firebaseUserProfile.family_member.name) !== null && _w !== void 0 ? _w : "");
            setFamilyMemberSurname((_x = firebaseUserProfile.family_member.surname) !== null && _x !== void 0 ? _x : "");
            setFamilyMemberRelationship((_y = firebaseUserProfile.family_member.relationship) !== null && _y !== void 0 ? _y : "");
            var familyCell = convertProfilePhoneToIPhone(firebaseUserProfile.family_member.cell_number);
            if (familyCell) {
                setFamilyMemberCellPhone(normalizePhoneForState(familyCell));
            }
            var familyHome = convertProfilePhoneToIPhone(firebaseUserProfile.family_member.home_number);
            if (familyHome) {
                setFamilyMemberHomePhone(normalizePhoneForState(familyHome));
            }
            var familyWork = convertProfilePhoneToIPhone(firebaseUserProfile.family_member.work_number);
            if (familyWork) {
                setFamilyMemberWorkPhone(normalizePhoneForState(familyWork));
            }
        }
        else {
        }
        // Friend contact - load from loan, fallback to user profile
        if (loan.friend) {
            setStringIfPresent(loan.friend.name, setFriendName);
            setStringIfPresent(loan.friend.surname, setFriendSurname);
            setPhoneIfPresent(loan.friend.cell_number, setFriendCellPhone);
            setPhoneIfPresent(loan.friend.home_number, setFriendHomePhone);
            setPhoneIfPresent(loan.friend.work_number, setFriendWorkPhone);
        }
        else if (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.friend) {
            // Fallback to user profile if not in loan
            setFriendName((_z = firebaseUserProfile.friend.name) !== null && _z !== void 0 ? _z : "");
            setFriendSurname((_0 = firebaseUserProfile.friend.surname) !== null && _0 !== void 0 ? _0 : "");
            var friendCell = convertProfilePhoneToIPhone(firebaseUserProfile.friend.cell_number);
            if (friendCell) {
                setFriendCellPhone(normalizePhoneForState(friendCell));
            }
            var friendHome = convertProfilePhoneToIPhone(firebaseUserProfile.friend.home_number);
            if (friendHome) {
                setFriendHomePhone(normalizePhoneForState(friendHome));
            }
            var friendWork = convertProfilePhoneToIPhone(firebaseUserProfile.friend.work_number);
            if (friendWork) {
                setFriendWorkPhone(normalizePhoneForState(friendWork));
            }
        }
        else {
        }
        // Employment — profile baseline, then loan overlay (per-field).
        // createLoanApplication seeds empty-string defaults for new drafts, so
        // the previous if-loan/else-profile pattern made the else branch
        // unreachable. setStringIfPresent is a no-op on empty values, so the
        // loan overlay only fills fields the user actually populated.
        var draftEmployment = loan.employment_details;
        var profileEmployment = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.employment_details;
        var setDateString = function (value, setter) {
            if (!value)
                return;
            var dateStr = "";
            if (typeof value === "string") {
                dateStr = value.split("T")[0];
            }
            else if (value instanceof Date) {
                dateStr = value.toISOString().split("T")[0];
            }
            else if (typeof value === "object" && "toDate" in value) {
                dateStr = value.toDate().toISOString().split("T")[0];
            }
            if (dateStr)
                setter(dateStr);
        };
        if (profileEmployment) {
            setStringIfPresent(profileEmployment.employment_status, setEmploymentStatus);
            setStringIfPresent(profileEmployment.monthly_income, setMonthlyIncome);
            setStringIfPresent(profileEmployment.employer, setEmployer);
            setStringIfPresent(profileEmployment.supervisor, setSupervisorName);
            setStringIfPresent(profileEmployment.department, setDepartmentNumber);
            setStringIfPresent(profileEmployment.employee_number, setEmployeeNumber);
            setStringIfPresent(profileEmployment.address, setWorkplaceAddress);
            setDateString(profileEmployment.appointment_date, setAppointmentDate);
            var workPhone = convertProfilePhoneToIPhone(profileEmployment.work_number);
            if (workPhone) {
                var normalized = normalizePhoneForState(workPhone);
                setWorkNumber(normalized);
                setEmployeePhoneNumber(normalized);
            }
        }
        if (draftEmployment) {
            setStringIfPresent(draftEmployment.employment_status, setEmploymentStatus);
            setStringIfPresent(draftEmployment.monthly_income, setMonthlyIncome);
            setStringIfPresent(draftEmployment.employer, setEmployer);
            setStringIfPresent(draftEmployment.supervisor, setSupervisorName);
            setStringIfPresent(draftEmployment.department, setDepartmentNumber);
            setStringIfPresent(draftEmployment.employee_number, setEmployeeNumber);
            setStringIfPresent(draftEmployment.address, setWorkplaceAddress);
            if (draftEmployment.address_location) {
                setWorkplaceAddressGeoPoint(draftEmployment.address_location);
            }
            setDateString(draftEmployment.appointment_date, setAppointmentDate);
            setPhoneIfPresent(draftEmployment.work_number, function (phone) {
                setWorkNumber(phone);
                setEmployeePhoneNumber(phone);
            });
        }
        setHasEditedYourEmployer(false);
        // Financial detail
        if (loan.financial_detail) {
            var financial = loan.financial_detail;
            setStringIfPresent(financial.housing, setHousingExpense);
            setStringIfPresent(financial.transport, setTransportExpense);
            setStringIfPresent(financial.education, setEducationExpense);
            setStringIfPresent(financial.electricity, setElectricityExpense);
            setStringIfPresent(financial.groceries_and_other, setGroceriesExpense);
            // Pay Frequency - Try loan first, fallback to profile
            if (financial.payment_frequency) {
                // Normalize to match dropdown options (e.g., "MONTHLY" -> "Monthly", "BI-WEEKLY" -> "Bi-Weekly")
                var freqMap = {
                    weekly: "Weekly",
                    "bi-weekly": "Bi-Weekly",
                    monthly: "Monthly",
                    quarterly: "Quarterly",
                };
                var normalized = freqMap[financial.payment_frequency.toLowerCase()] ||
                    financial.payment_frequency;
                setPayFrequency(normalized);
            }
            else if ((_1 = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.financial_detail) === null || _1 === void 0 ? void 0 : _1.payment_frequency) {
                // Fallback to profile
                var freqMap = {
                    weekly: "Weekly",
                    "bi-weekly": "Bi-Weekly",
                    monthly: "Monthly",
                    quarterly: "Quarterly",
                };
                var normalized = freqMap[firebaseUserProfile.financial_detail.payment_frequency.toLowerCase()] || firebaseUserProfile.financial_detail.payment_frequency;
                setPayFrequency(normalized);
            }
            // Pay Day - Try loan first, fallback to profile
            var extractDayFromValue = function (value) {
                if (!value)
                    return null;
                // If it's a number, convert to string
                if (typeof value === "number") {
                    return String(value);
                }
                var strValue = String(value);
                // If it's a date string (YYYY-MM-DD), extract the day
                if (strValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
                    var day = parseInt(strValue.split("-")[2], 10);
                    return String(day);
                }
                // Otherwise return as-is
                return strValue;
            };
            if (financial.preferred_payday) {
                var payDayValue = extractDayFromValue(financial.preferred_payday);
                if (payDayValue) {
                    setPayDate(payDayValue);
                }
            }
            else if ((_2 = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.financial_detail) === null || _2 === void 0 ? void 0 : _2.preferred_payday) {
                var payDayValue = extractDayFromValue(firebaseUserProfile.financial_detail.preferred_payday);
                if (payDayValue) {
                    setPayDate(payDayValue);
                }
            }
            else {
            }
            var toExpenseItems = function (items) {
                return Array.isArray(items) && items.length > 0
                    ? items.map(function (item, index) {
                        // Detect corrupted description data (IDs saved as descriptions)
                        var isCorruptedId = item.key && /^item_\d+(_item_\d+)*(_\d+)?$/.test(item.key);
                        return {
                            id: "item_".concat(Date.now(), "_").concat(index), // Generate fresh ID
                            description: isCorruptedId ? "" : item.key || "", // Clear corrupted IDs
                            amount: item.value || "0.00",
                        };
                    })
                    : undefined;
            };
            var payments = toExpenseItems(financial.account_payments);
            if (payments)
                setAccountPayments(payments);
            var deductions = toExpenseItems(financial.fixed_monthly_deductions);
            if (deductions)
                setFixedDeductions(deductions);
            var obligations = toExpenseItems(financial.other_obligations);
            if (obligations)
                setOtherObligations(obligations);
        }
        // HR/Paypoint Details — profile baseline, then loan overlay (per-field).
        // Sky Web stores HR data in paypoint_details: paymaster_number = HR
        // Name, phone_number = HR Phone Number. paymaster_name/paymaster_phone
        // are loan-document-only fields (CRM-side) and have no profile source.
        var draftPaypoint = loan.paypoint_details;
        var profilePaypoint = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.paypoint_details;
        if (profilePaypoint) {
            setStringIfPresent(profilePaypoint.paymaster_number, setHRName);
            var hrPhone = convertProfilePhoneToIPhone(profilePaypoint.phone_number);
            if (hrPhone) {
                setHRPhoneNumber(normalizePhoneForState(hrPhone));
            }
            setStringIfPresent(profilePaypoint.postal_address, setPayPointPostalAddress);
            setStringIfPresent(profilePaypoint.physical_address, setPayPointPhysicalAddress);
            setStringIfPresent(profilePaypoint.postal_code, setPostalCode);
        }
        if (draftPaypoint) {
            setStringIfPresent(draftPaypoint.paymaster_number, setHRName);
            setPhoneIfPresent(draftPaypoint.phone_number, setHRPhoneNumber);
            setStringIfPresent(draftPaypoint.postal_address, setPayPointPostalAddress);
            if (draftPaypoint.postal_address_location) {
                setPayPointPostalAddressGeoPoint(draftPaypoint.postal_address_location);
            }
            setStringIfPresent(draftPaypoint.physical_address, setPayPointPhysicalAddress);
            if (draftPaypoint.physical_address_location) {
                setPayPointPhysicalAddressGeoPoint(draftPaypoint.physical_address_location);
            }
            setStringIfPresent(draftPaypoint.postal_code, setPostalCode);
            var paypointAny = draftPaypoint;
            if (paypointAny.paymaster_name) {
                setPaymasterName(paypointAny.paymaster_name);
            }
            if ((_3 = paypointAny.paymaster_phone) === null || _3 === void 0 ? void 0 : _3.phone_number) {
                setPayPointPhoneNumber(paypointAny.paymaster_phone);
            }
        }
        // Banking - load the canonical loan field, with legacy-record fallback.
        var loanBanking = loan.salary_bank_details || loan.salary_bank;
        // Banking - Try loan first, fallback to profile for any missing fields
        var bankSet = false;
        var branchSet = false;
        var accountNumberSet = false;
        var accountTypeSet = false;
        if (loanBanking) {
            var bank = loanBanking;
            if (bank.bank && bank.bank.trim()) {
                setSelectedBank(bank.bank);
                bankSet = true;
            }
            if (bank.branch && bank.branch.trim()) {
                setBankBranch(bank.branch);
                branchSet = true;
            }
            if (bank.account_number && bank.account_number.trim()) {
                setAccountNumber(bank.account_number);
                accountNumberSet = true;
            }
            if (bank.account_type && bank.account_type.trim()) {
                setAccountType(bank.account_type);
                accountTypeSet = true;
            }
        }
        // Fallback to profile for any fields not set from loan
        if (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.salary_bank) {
            var profile = firebaseUserProfile.salary_bank;
            // Helper to normalize bank names
            var normalizeBankName = function (bank) {
                var bankLower = bank.toLowerCase().trim();
                if (bankLower === "fnb" || bankLower === "fnb namibia")
                    return "FNB Namibia";
                if (bankLower === "bank windhoek" || bankLower === "windhoek")
                    return "Bank Windhoek";
                if (bankLower === "standard" || bankLower === "standard bank")
                    return "Standard Bank";
                if (bankLower === "nedbank" || bankLower === "nedbank namibia")
                    return "Nedbank Namibia";
                return bank; // Return original if no match
            };
            // Helper to normalize account type
            var normalizeAccountType = function (type) {
                var typeLower = type.toLowerCase().trim();
                if (typeLower === "savings")
                    return "Savings";
                if (typeLower === "current")
                    return "Current";
                if (typeLower === "cheque")
                    return "Cheque";
                return type; // Return original if no match
            };
            if (!bankSet && profile.bank) {
                var normalizedBank = normalizeBankName(profile.bank);
                setSelectedBank(normalizedBank);
            }
            if (!branchSet && profile.branch) {
                setBankBranch(profile.branch);
            }
            if (!accountNumberSet && profile.account_number) {
                setAccountNumber(profile.account_number);
            }
            if (!accountTypeSet && profile.account_type) {
                var normalizedType = normalizeAccountType(profile.account_type);
                setAccountType(normalizedType);
            }
        }
        // Loan amount & term
        var amountValue = typeof loan.amount === "number"
            ? loan.amount
            : typeof loan.original_amount === "number"
                ? loan.original_amount
                : undefined;
        if (typeof amountValue === "number") {
            setLoanAmount(amountValue.toFixed(2));
        }
        else {
            setLoanAmount(LOAN_AMOUNT_LIMITS.DEFAULT.toFixed(2));
        }
        if (loan.term) {
            // Normalize loan term to handle old format ("5 Months" → "5 MONTHS")
            setLoanTerm((0, loan_data_mapper_1.normalizeLoanTerm)(loan.term));
        }
        var providerId = getRefId(loan.provider);
        if (providerId) {
            setSelectedProviderId(providerId);
            // Branches are already loaded by useGetSiteProviderQuery
        }
        var branchId = getRefId(loan.branch);
        if (branchId) {
            setSelectedBranch(branchId);
        }
        if (loan.force_number) {
            setForceNumber(loan.force_number);
        }
        if ((_4 = loan.bank_debit_signature) === null || _4 === void 0 ? void 0 : _4.signature) {
            setBankSignatureURL(loan.bank_debit_signature.signature);
        }
        if ((_5 = loan.salary_deduction_signature) === null || _5 === void 0 ? void 0 : _5.signature) {
            setSignatureURL(loan.salary_deduction_signature.signature);
            setSignedDocumentUrl(loan.salary_deduction_signature.signature);
        }
        if (Array.isArray(loan.bank_statements) && loan.bank_statements.length) {
            setBankStatementsUrl(loan.bank_statements);
        }
        if (loan.latest_payslip) {
            setLatestPayslipUrl(loan.latest_payslip);
        }
        setConfirmationChecked(Boolean(loan.agree_terms));
    }, [LOAN_AMOUNT_LIMITS.DEFAULT, firebaseUserProfile]);
    // Batch update handler for step renderer
    var handleFormDataUpdate = (0, react_1.useCallback)(function (updates) {
        Object.entries(updates).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            switch (key) {
                // Personal info (maps firstName/lastName to name/surname)
                case "firstName":
                    setName(value);
                    break;
                case "lastName":
                    setSurname(value);
                    break;
                case "idNumber":
                    setIdNumber(value);
                    break;
                case "gender":
                    setGender(value);
                    break;
                case "homeAddress":
                    if (typeof value === "string") {
                        setHomeAddress({
                            full_address: value,
                            location: homeAddressGeoPoint || undefined,
                        });
                    }
                    break;
                case "homeAddressGeoPoint":
                    setHomeAddressGeoPoint(value);
                    break;
                case "postalAddress":
                    setPostalAddress(value);
                    break;
                case "postalAddressGeoPoint":
                    setPostalAddressGeoPoint(value);
                    break;
                case "isMarried":
                    setIsMarried(value);
                    break;
                case "marriageType":
                    setMarriageType(value);
                    break;
                // Spouse details
                case "spouseFirstName":
                    setSpouseName(value);
                    break;
                case "spouseLastName":
                    setSpouseLastName(value);
                    break;
                case "spousePhoneNumber":
                    setSpousePhoneNumber(value);
                    break;
                case "spouseHomeNumber":
                    setSpouseHomeNumber(value);
                    break;
                case "spouseWorkNumber":
                    setSpouseWorkNumber(value);
                    break;
                // Family member
                case "familyMemberName":
                    setFamilyMemberName(value);
                    break;
                case "familyMemberSurname":
                    setFamilyMemberSurname(value);
                    break;
                case "familyMemberRelationship":
                    setFamilyMemberRelationship(value);
                    break;
                case "familyMemberCellPhone":
                    setFamilyMemberCellPhone(value);
                    break;
                case "familyMemberWorkPhone":
                    setFamilyMemberWorkPhone(value);
                    break;
                case "familyMemberHomePhone":
                    setFamilyMemberHomePhone(value);
                    break;
                // Friend
                case "friendName":
                    setFriendName(value);
                    break;
                case "friendSurname":
                    setFriendSurname(value);
                    break;
                case "friendCellPhone":
                    setFriendCellPhone(value);
                    break;
                case "friendWorkPhone":
                    setFriendWorkPhone(value);
                    break;
                case "friendHomePhone":
                    setFriendHomePhone(value);
                    break;
                // Loan details
                case "loanAmount":
                    setLoanAmount(value);
                    break;
                case "loanTerm":
                    setLoanTerm(value);
                    break;
                case "selectedProviderId":
                    setSelectedProviderId(value);
                    break;
                case "selectedBranch":
                    setSelectedBranch(value);
                    break;
                // Employment
                case "employmentStatus":
                    setEmploymentStatus(value);
                    break;
                case "monthlyIncome":
                    setMonthlyIncome(value);
                    break;
                case "employer":
                    setEmployer(value);
                    break;
                case "supervisorName":
                    setSupervisorName(value);
                    break;
                case "workNumber":
                    setWorkNumber(value);
                    break;
                case "departmentNumber":
                    setDepartmentNumber(value);
                    break;
                case "employeeNumber":
                    setEmployeeNumber(value);
                    break;
                case "workplaceAddress":
                    setWorkplaceAddress(value);
                    break;
                case "workplaceAddressGeoPoint":
                    setWorkplaceAddressGeoPoint(value);
                    break;
                case "appointmentDate":
                    setAppointmentDate(value);
                    break;
                // HR/Paymaster details
                case "paymasterName":
                    setPaymasterName(value);
                    break;
                case "paymasterPhoneNumber":
                    setPayPointPhoneNumber(value);
                    break;
                case "hrName":
                    setHRName(value);
                    break;
                case "hrPhoneNumber":
                    setHRPhoneNumber(value);
                    break;
                case "hrPostalAddress":
                    setPayPointPostalAddress(value);
                    break;
                case "hrPostalAddressGeoPoint":
                    setPayPointPostalAddressGeoPoint(value);
                    break;
                case "hrPostalCode":
                    setPostalCode(value);
                    break;
                case "hrPhysicalAddress":
                    setPayPointPhysicalAddress(value);
                    break;
                case "hrPhysicalAddressGeoPoint":
                    setPayPointPhysicalAddressGeoPoint(value);
                    break;
                // Banking
                case "bank":
                    setSelectedBank(value);
                    break;
                case "branch":
                    setBankBranch(value);
                    break;
                case "accountNumber":
                    setAccountNumber(value);
                    break;
                case "accountType":
                    setAccountType(value);
                    break;
                // Financial details
                case "payFrequency":
                    setPayFrequency(value);
                    break;
                case "payDate":
                    setPayDate(value);
                    break;
                case "housingExpense":
                    setHousingExpense(value);
                    break;
                case "transportExpense":
                    setTransportExpense(value);
                    break;
                case "educationExpense":
                    setEducationExpense(value);
                    break;
                case "electricityExpense":
                    setElectricityExpense(value);
                    break;
                case "groceriesExpense":
                    setGroceriesExpense(value);
                    break;
                case "accountPayments":
                    setAccountPayments(value);
                    break;
                case "fixedDeductions":
                    setFixedDeductions(value);
                    break;
                case "otherObligations":
                    setOtherObligations(value);
                    break;
                // Documents
                case "payslipFile":
                    setSalaryBankingDoc1(value);
                    break;
                case "bankStatementFiles":
                    setSalaryBankingDoc2(value);
                    break;
                // Signatures
                case "salaryDeductionSignatureURL":
                    setSignatureURL(value);
                    break;
                case "electronicPaymentsSignatureURL":
                    setBankSignatureURL(value);
                    break;
                case "forceNumber":
                    setForceNumber(value);
                    break;
                // Close modal
                case "close":
                    if (value === true) {
                        // Close modal and return to home screen
                        onClose();
                    }
                    break;
            }
            // Clear the error for this field when it's updated
            if (key !== "close" && key !== "errors") {
                setErrors(function (prev) {
                    if (prev[key]) {
                        var _a = prev, _b = key, _ = _a[_b], rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
                        return rest;
                    }
                    return prev;
                });
            }
        });
    }, []);
    var resolveFirebaseUid = function () {
        var _a;
        // Authoritative source first (live Firebase Auth session)
        if ((_a = firebase_1.auth.currentUser) === null || _a === void 0 ? void 0 : _a.uid) {
            return firebase_1.auth.currentUser.uid;
        }
        if (user === null || user === void 0 ? void 0 : user.firebase_user_id) {
            return user.firebase_user_id;
        }
        if (user === null || user === void 0 ? void 0 : user.user_id) {
            return user.user_id;
        }
        try {
            var storedUid = localStorage.getItem("firebase_user_id");
            if (storedUid) {
                return storedUid;
            }
        }
        catch (storageError) {
            console.warn("Unable to read firebase_user_id from localStorage:", storageError);
        }
        if (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.uid) {
            return firebaseUserProfile.uid;
        }
        return undefined;
    };
    // Full modal state reset — shared between isOpen effect and deferred post-submission reset
    var resetModalState = function () {
        remoteDraftLoadedRef.current = false;
        loadedDraftForProfileReplayRef.current = null;
        hasResumedStepRef.current = false;
        isManualNavigationRef.current = false;
        setCurrentStep(step_constants_1.STEP_START);
        setCurrentApplicationId(null);
        currentApplicationIdRef.current = null;
        // Clear signatures
        setSignatureURL("");
        setBankSignatureURL("");
        setSignedDocumentUrl("");
        setSignatureError("");
        setBankSignatureError("");
        setIsSavingSignature(false);
        setIsSavingBankSignature(false);
        // Clear document uploads
        setSalaryBankingDoc1(null);
        setSalaryBankingDoc2([]);
        setLatestPayslipUrl("");
        setBankStatementsUrl([]);
        // Clear signature canvases
        if (signatureRef.current) {
            signatureRef.current.clear();
        }
        if (bankSignatureRef.current) {
            bankSignatureRef.current.clear();
        }
    };
    var populateFromDraftLoan = (0, react_1.useCallback)(function (loanRecord) {
        remoteDraftLoadedRef.current = true;
        loadedDraftForProfileReplayRef.current = loanRecord;
        if (loanRecord.uid) {
            setCurrentApplicationId(loanRecord.uid);
            currentApplicationIdRef.current = loanRecord.uid;
        }
        // Pre-fill form data from draft/current loan
        applyMappedLoanData(loanRecord);
        // If draft has no amount (brand new), use initialAmount from home screen OR default amount
        var draftAmount = typeof loanRecord.amount === "number" ? loanRecord.amount : 0;
        if (draftAmount > 0) {
            setLoanAmount(draftAmount.toFixed(2));
        }
        else {
            var amountToUse = initialAmount || LOAN_AMOUNT_LIMITS.DEFAULT;
            setLoanAmount(amountToUse.toFixed(2));
        }
        // Auto-resume at last edited step (only on initial load, not on re-renders)
        // This prevents overriding manual back navigation.
        if (!hasResumedStepRef.current) {
            var resumeStep = (0, step_constants_1.getLastEditedStep)(loanRecord, kycCompleted);
            setCurrentStep(resumeStep);
            hasResumedStepRef.current = true;
        }
        // Mark KYC completed if either the draft says so or the profile is already verified
        var hasCompletedKyc = !!loanRecord.kyc_complete ||
            (0, user_state_1.isKycVerified)(user, firebaseUserProfile);
        setKycCompleted(hasCompletedKyc);
        setKycError(null);
    }, [
        LOAN_AMOUNT_LIMITS.DEFAULT,
        applyMappedLoanData,
        firebaseUserProfile,
        initialAmount,
        kycCompleted,
        user,
    ]);
    // Reset modal state when it opens
    (0, react_1.useEffect)(function () {
        if (isOpen) {
            if (isSubmittingRef.current) {
                pendingResetRef.current = true; // Will reset after submission completes
                return;
            }
            pendingResetRef.current = false;
            resetModalState();
        }
    }, [isOpen]); // ONLY run when modal opens/closes, not on every state change
    // If a draft loan is provided by the parent, prioritize it for modal data population.
    // Existing remote draft loading remains as a fallback when currentLoan is not provided.
    (0, react_1.useEffect)(function () {
        if (!isOpen ||
            forceNewApplication ||
            !currentLoan ||
            remoteDraftLoadedRef.current) {
            return;
        }
        var loanFromProps = currentLoan;
        populateFromDraftLoan(loanFromProps);
    }, [currentLoan, populateFromDraftLoan, isOpen]);
    (0, react_1.useEffect)(function () {
        var userId = resolveFirebaseUid();
        // Wait for provider to be loaded before fetching draft
        if (forceNewApplication ||
            remoteDraftLoadedRef.current ||
            !userId ||
            !selectedProviderId) {
            return;
        }
        var isMounted = true;
        var fetchDraft = function () { return __awaiter(void 0, void 0, void 0, function () {
            var response, loanRecord, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        setIsCheckingDraft(true); // Show "Checking for draft..." indicator
                        return [4 /*yield*/, (0, application_1.getOrCreateDraftLoan)(userId, selectedProviderId, selectedBranch)];
                    case 1:
                        response = _a.sent();
                        if (!isMounted)
                            return [2 /*return*/];
                        if (response.success && response.content) {
                            loanRecord = response.content;
                            // Only load if status is DRAFT (skip submitted applications)
                            if (loanRecord.status === "DRAFT") {
                                populateFromDraftLoan(loanRecord);
                            }
                            else {
                                console.warn("Draft loan has non-DRAFT status:", loanRecord.status);
                            }
                        }
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Error loading/creating draft loan:", error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        setIsCheckingDraft(false); // Hide "Checking for draft..." indicator
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchDraft();
        return function () {
            isMounted = false;
        };
    }, [
        forceNewApplication,
        populateFromDraftLoan,
        user === null || user === void 0 ? void 0 : user.firebase_user_id,
        selectedProviderId,
        siteConfig,
    ]);
    // Pre-fill user data from auth state (basic info only)
    (0, react_1.useEffect)(function () {
        if (remoteDraftLoadedRef.current) {
            return;
        }
        // Load basic user data from auth state
        if (user) {
            if (user.name) {
                setName(function (prev) { return prev || user.name; });
                setEmployeeName(function (prev) { return prev || user.name; });
            }
            if (user.surname) {
                setSurname(function (prev) { return prev || user.surname; });
                setEmployeeSurname(function (prev) { return prev || user.surname; });
            }
            if (user.cell_number) {
                var countryAbbreviation = user.cell_number
                    .country_abbreviation ||
                    "NA";
                setEmployeePhoneNumber({
                    phone_number: (0, phone_utils_1.enforcePhoneNumberLength)(user.cell_number.phone_number || "", countryAbbreviation),
                    country_code: user.cell_number.country_code || "+264",
                    country_abbreviation: countryAbbreviation,
                });
            }
        }
    }, [user]);
    (0, react_1.useEffect)(function () {
        if (!hasEditedYourEmployer) {
            setYourEmployer(employer || ""); // Keep authorization employer in sync when user has not edited it manually.
        }
    }, [employer, hasEditedYourEmployer]);
    // Validate Step 2 (Personal Details) when landing on it to catch invalid prepopulated data
    (0, react_1.useEffect)(function () {
        if (currentStep === step_constants_1.STEP_PERSONAL_DETAILS && isOpen) {
            // Small delay to ensure all state has been set after data load
            var timer_1 = setTimeout(function () {
                // Only validate if there's spouse phone data (not a fresh empty form)
                var hasSpouseData = isMarried &&
                    ((spousePhoneNumber === null || spousePhoneNumber === void 0 ? void 0 : spousePhoneNumber.phone_number) ||
                        (spouseHomeNumber === null || spouseHomeNumber === void 0 ? void 0 : spouseHomeNumber.phone_number) ||
                        (spouseWorkNumber === null || spouseWorkNumber === void 0 ? void 0 : spouseWorkNumber.phone_number));
                if (hasSpouseData) {
                    validatePersonalStep();
                }
            }, 100);
            return function () { return clearTimeout(timer_1); };
        }
    }, [
        currentStep,
        isOpen,
        isMarried,
        spousePhoneNumber,
        spouseHomeNumber,
        spouseWorkNumber,
    ]);
    // Validate Step 3 (Family Contacts) when landing on it to catch invalid prepopulated data
    (0, react_1.useEffect)(function () {
        if (currentStep === step_constants_1.STEP_FAMILY_CONTACTS && isOpen) {
            // Small delay to ensure all state has been set after data load
            var timer_2 = setTimeout(function () {
                // Only validate if there's data (not a fresh empty form)
                var hasData = (familyMemberCellPhone === null || familyMemberCellPhone === void 0 ? void 0 : familyMemberCellPhone.phone_number) || (friendCellPhone === null || friendCellPhone === void 0 ? void 0 : friendCellPhone.phone_number);
                if (hasData) {
                    var isValid = validateFamilyContactsStep();
                }
            }, 100);
            return function () { return clearTimeout(timer_2); };
        }
    }, [currentStep, isOpen, familyMemberCellPhone, friendCellPhone]);
    // Validate Step 4 (Employment Details) when landing on it to catch invalid prepopulated work phone
    (0, react_1.useEffect)(function () {
        if (currentStep === step_constants_1.STEP_EMPLOYMENT && isOpen) {
            // Small delay to ensure all state has been set after data load
            var timer_3 = setTimeout(function () {
                // Only validate if there's employment data and user is employed
                var isEmployed = employmentRequiresSalaryDeduction(employmentStatus);
                var hasWorkPhone = workNumber === null || workNumber === void 0 ? void 0 : workNumber.phone_number;
                if (isEmployed && hasWorkPhone) {
                    // Run employment validation which includes work phone validation
                    var validationErrors_1 = (0, loan_application_validators_1.validateEmploymentDetails)(employmentStatus, monthlyIncome, employer, supervisorName, workNumber, departmentNumber, workplaceAddress, employeeNumber, appointmentDate);
                    // Update errors - both set new errors AND clear fixed errors
                    setErrors(function (prevErrors) {
                        var newErrors = __assign({}, prevErrors);
                        // Clear employment-related errors first
                        delete newErrors.employmentStatus;
                        delete newErrors.monthlyIncome;
                        delete newErrors.employer;
                        delete newErrors.supervisorName;
                        delete newErrors.workNumber;
                        delete newErrors.departmentNumber;
                        delete newErrors.workplaceAddress;
                        delete newErrors.employeeNumber;
                        delete newErrors.appointmentDate;
                        // Add back any validation errors found
                        return __assign(__assign({}, newErrors), validationErrors_1);
                    });
                }
            }, 100);
            return function () { return clearTimeout(timer_3); };
        }
    }, [currentStep, isOpen, employmentStatus, workNumber]);
    // Validate Step 5 (HR Details) when landing on it to catch invalid prepopulated phone numbers
    (0, react_1.useEffect)(function () {
        if (currentStep === step_constants_1.STEP_HR_DETAILS && isOpen) {
            // Small delay to ensure all state has been set after data load
            var timer_4 = setTimeout(function () {
                // Only validate if there's phone data (optional fields)
                var hasPaymasterPhone = payPointPhoneNumber === null || payPointPhoneNumber === void 0 ? void 0 : payPointPhoneNumber.phone_number;
                var hasHRPhone = hrPhoneNumber === null || hrPhoneNumber === void 0 ? void 0 : hrPhoneNumber.phone_number;
                if (hasPaymasterPhone || hasHRPhone) {
                    // Run HR validation which includes phone validations
                    var validationErrors_2 = {};
                    // Validate paymaster phone if provided
                    if (hasPaymasterPhone) {
                        var lengthError = (0, phone_utils_1.getPhoneLengthError)(payPointPhoneNumber, "Paymaster phone number");
                        if (lengthError) {
                            validationErrors_2.paymasterPhoneNumber = lengthError;
                        }
                    }
                    // Validate HR phone if provided
                    if (hasHRPhone) {
                        var lengthError = (0, phone_utils_1.getPhoneLengthError)(hrPhoneNumber, "HR phone number");
                        if (lengthError) {
                            validationErrors_2.hrPhoneNumber = lengthError;
                        }
                    }
                    // Update errors - clear HR-related errors first, then apply new ones
                    setErrors(function (prevErrors) {
                        var newErrors = __assign({}, prevErrors);
                        // Clear HR-related errors
                        delete newErrors.paymasterName;
                        delete newErrors.paymasterPhoneNumber;
                        delete newErrors.hrPhoneNumber;
                        delete newErrors.hrPostalAddress;
                        delete newErrors.hrPhysicalAddress;
                        // Add back any validation errors found
                        return __assign(__assign({}, newErrors), validationErrors_2);
                    });
                }
            }, 100);
            return function () { return clearTimeout(timer_4); };
        }
    }, [currentStep, isOpen, payPointPhoneNumber, hrPhoneNumber]);
    // Validate Step 6 (Salary Banking) when landing on it to catch invalid prepopulated data
    (0, react_1.useEffect)(function () {
        if (currentStep === step_constants_1.STEP_SALARY_BANKING && isOpen) {
            // Small delay to ensure all state has been set after data load
            var timer_5 = setTimeout(function () {
                // Only validate if there's banking data (not a fresh empty form)
                var hasData = selectedBank || bankBranch || accountNumber || accountType;
                if (hasData) {
                    validateSalaryBankingStep();
                }
            }, 100);
            return function () { return clearTimeout(timer_5); };
        }
    }, [
        currentStep,
        isOpen,
        selectedBank,
        bankBranch,
        accountNumber,
        accountType,
    ]);
    // Load provider and branches from backend (handles matching logic server-side)
    var _102 = (0, sites_1.useGetSiteProviderQuery)((siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig._id) || "", {
        // Only fetch once the user is authenticated (Firebase token available) and we have a site id
        skip: !(siteConfig === null || siteConfig === void 0 ? void 0 : siteConfig._id) || !auth.access_token,
    }), providerData = _102.data, isLoadingProvider = _102.isLoading, providerError = _102.error;
    // Seed selected provider from site config immediately (no auth required)
    // useEffect(() => {
    //   if (siteConfig?.providerId) {
    //     setSelectedProviderId(siteConfig.providerId);
    //     // Add a placeholder option so the start step shows a label
    //     setProviders((prev) => {
    //       const exists = prev.some((p) => p.value === siteConfig.providerId);
    //       if (exists) return prev;
    //       return [
    //         {
    //           value: siteConfig.providerId,
    //           label:
    //             providerData?.content?.provider?.name || siteConfig.providerId,
    //         },
    //         ...prev,
    //       ];
    //     });
    //   }
    // }, [siteConfig?.providerId, providerData]);
    // Update state when provider data is loaded
    (0, react_1.useEffect)(function () {
        if ((providerData === null || providerData === void 0 ? void 0 : providerData.success) && providerData.content) {
            var _a = providerData.content, provider_1 = _a.provider, branches_1 = _a.branches;
            // Set provider info
            setLender(provider_1.name);
            setSelectedProviderId(provider_1.id);
            setProvider({
                value: provider_1.id,
                label: provider_1.name,
            });
            setLoadingProviders(false);
            // Set branches
            var branchOptions = branches_1.map(function (branch) { return ({
                value: branch.id,
                label: branch.name,
            }); });
            setBranches(branchOptions);
            setLoadingBranches(false);
        }
        else if (providerError) {
            console.error("Error loading provider:", providerError);
            setLoadingProviders(false);
            setLoadingBranches(false);
        }
    }, [providerData, providerError]);
    // Sync loading state
    (0, react_1.useEffect)(function () {
        setLoadingProviders(isLoadingProvider);
        setLoadingBranches(isLoadingProvider);
    }, [isLoadingProvider]);
    var validatePersonalStep = function () {
        var _a, _b, _c, _d, _e, _f;
        var newErrors = {};
        var trimmedName = name === null || name === void 0 ? void 0 : name.trim();
        if (!trimmedName)
            newErrors.name = "Please enter your Name";
        var trimmedSurname = surname === null || surname === void 0 ? void 0 : surname.trim();
        if (!trimmedSurname)
            newErrors.surname = "Please enter your Surname";
        var trimmedIdNumber = idNumber === null || idNumber === void 0 ? void 0 : idNumber.trim();
        if (!trimmedIdNumber)
            newErrors.idNumber = "Please enter your ID number";
        // Note: employeePhoneNumber validation removed - field is pre-populated from user profile
        // and displayed read-only in Step 9 (Authorization Salary Deduction). No input exists in this step.
        var trimmedHomeAddress = (_a = homeAddress === null || homeAddress === void 0 ? void 0 : homeAddress.full_address) === null || _a === void 0 ? void 0 : _a.trim();
        if (!trimmedHomeAddress)
            newErrors.homeAddress = "Please enter your home address";
        // Client update: postal address optional so no error when blank.
        if (!gender)
            newErrors.gender = "Please select your gender";
        // Marriage validation
        if (isMarried === null)
            newErrors.isMarried = "Please select your marriage status";
        if (isMarried === true) {
            if (!marriageType)
                newErrors.marriageType = "Please select marriage type";
            var trimmedSpouseName = spouseName === null || spouseName === void 0 ? void 0 : spouseName.trim();
            if (!trimmedSpouseName)
                newErrors.spouseName = "Please enter spouse name";
            var trimmedSpouseLastName = spouseLastName === null || spouseLastName === void 0 ? void 0 : spouseLastName.trim();
            if (!trimmedSpouseLastName)
                newErrors.spouseLastName = "Please enter spouse last name";
            var spousePhoneValue = (_b = spousePhoneNumber === null || spousePhoneNumber === void 0 ? void 0 : spousePhoneNumber.phone_number) === null || _b === void 0 ? void 0 : _b.trim();
            if (!spousePhoneValue)
                newErrors.spousePhoneNumber = "Please enter spouse phone number";
            if (!newErrors.spousePhoneNumber) {
                var lengthError = (0, phone_utils_1.getPhoneLengthError)(spousePhoneNumber, "Spouse phone number");
                if (lengthError) {
                    newErrors.spousePhoneNumber = lengthError;
                }
            }
            var spouseHomePhoneValue = (_d = (_c = spouseHomeNumber === null || spouseHomeNumber === void 0 ? void 0 : spouseHomeNumber.phone_number) === null || _c === void 0 ? void 0 : _c.trim()) !== null && _d !== void 0 ? _d : "";
            if (spouseHomePhoneValue) {
                var lengthError = (0, phone_utils_1.getPhoneLengthError)(spouseHomeNumber, "Spouse home number");
                if (lengthError) {
                    newErrors.spouseHomeNumber = lengthError;
                }
            }
            var spouseWorkPhoneValue = (_f = (_e = spouseWorkNumber === null || spouseWorkNumber === void 0 ? void 0 : spouseWorkNumber.phone_number) === null || _e === void 0 ? void 0 : _e.trim()) !== null && _f !== void 0 ? _f : "";
            if (spouseWorkPhoneValue) {
                var lengthError = (0, phone_utils_1.getPhoneLengthError)(spouseWorkNumber, "Spouse work number");
                if (lengthError) {
                    newErrors.spouseWorkNumber = lengthError;
                }
            }
        }
        // Note: Family Member and Friend validation moved to validateFamilyContactsStep()
        // These fields are in Step 4 (Family & Friend), not Step 3 (Personal Details)
        // Log validation results
        if (Object.keys(newErrors).length > 0) {
            console.error("❌ Personal Details validation errors:", newErrors);
        }
        else {
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    var validateFamilyContactsStep = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        var newErrors = {};
        // Family Member validations (required fields)
        var trimmedFamilyMemberName = familyMemberName === null || familyMemberName === void 0 ? void 0 : familyMemberName.trim();
        if (!trimmedFamilyMemberName) {
            newErrors.familyMemberName = "Please enter family member name";
        }
        var trimmedFamilyMemberSurname = familyMemberSurname === null || familyMemberSurname === void 0 ? void 0 : familyMemberSurname.trim();
        if (!trimmedFamilyMemberSurname) {
            newErrors.familyMemberSurname = "Please enter family member surname";
        }
        var trimmedRelationship = familyMemberRelationship === null || familyMemberRelationship === void 0 ? void 0 : familyMemberRelationship.trim();
        if (!trimmedRelationship) {
            newErrors.familyMemberRelationship = "Please select relationship";
        }
        var familyMemberCellValue = (_a = familyMemberCellPhone === null || familyMemberCellPhone === void 0 ? void 0 : familyMemberCellPhone.phone_number) === null || _a === void 0 ? void 0 : _a.trim();
        if (!familyMemberCellValue) {
            newErrors.familyMemberCellPhone =
                "Please enter family member cell number";
        }
        else {
            var lengthError = (0, phone_utils_1.getPhoneLengthError)(familyMemberCellPhone, "Family member cell number");
            if (lengthError) {
                newErrors.familyMemberCellPhone = lengthError;
            }
        }
        // Family member optional phone numbers (only validate if provided)
        var familyMemberHomeValue = (_c = (_b = familyMemberHomePhone === null || familyMemberHomePhone === void 0 ? void 0 : familyMemberHomePhone.phone_number) === null || _b === void 0 ? void 0 : _b.trim()) !== null && _c !== void 0 ? _c : "";
        if (familyMemberHomeValue) {
            var lengthError = (0, phone_utils_1.getPhoneLengthError)(familyMemberHomePhone, "Family member home number");
            if (lengthError) {
                newErrors.familyMemberHomePhone = lengthError;
            }
        }
        var familyMemberWorkValue = (_e = (_d = familyMemberWorkPhone === null || familyMemberWorkPhone === void 0 ? void 0 : familyMemberWorkPhone.phone_number) === null || _d === void 0 ? void 0 : _d.trim()) !== null && _e !== void 0 ? _e : "";
        if (familyMemberWorkValue) {
            var lengthError = (0, phone_utils_1.getPhoneLengthError)(familyMemberWorkPhone, "Family member work number");
            if (lengthError) {
                newErrors.familyMemberWorkPhone = lengthError;
            }
        }
        // Friend validations (required fields)
        var trimmedFriendName = friendName === null || friendName === void 0 ? void 0 : friendName.trim();
        if (!trimmedFriendName) {
            newErrors.friendName = "Please enter friend name";
        }
        var trimmedFriendSurname = friendSurname === null || friendSurname === void 0 ? void 0 : friendSurname.trim();
        if (!trimmedFriendSurname) {
            newErrors.friendSurname = "Please enter friend surname";
        }
        var friendCellValue = (_f = friendCellPhone === null || friendCellPhone === void 0 ? void 0 : friendCellPhone.phone_number) === null || _f === void 0 ? void 0 : _f.trim();
        if (!friendCellValue) {
            newErrors.friendCellPhone = "Please enter friend cell number";
        }
        else {
            var lengthError = (0, phone_utils_1.getPhoneLengthError)(friendCellPhone, "Friend cell number");
            if (lengthError) {
                newErrors.friendCellPhone = lengthError;
            }
        }
        // Friend optional phone numbers (only validate if provided)
        var friendHomeValue = (_h = (_g = friendHomePhone === null || friendHomePhone === void 0 ? void 0 : friendHomePhone.phone_number) === null || _g === void 0 ? void 0 : _g.trim()) !== null && _h !== void 0 ? _h : "";
        if (friendHomeValue) {
            var lengthError = (0, phone_utils_1.getPhoneLengthError)(friendHomePhone, "Friend home number");
            if (lengthError) {
                newErrors.friendHomePhone = lengthError;
            }
        }
        var friendWorkValue = (_k = (_j = friendWorkPhone === null || friendWorkPhone === void 0 ? void 0 : friendWorkPhone.phone_number) === null || _j === void 0 ? void 0 : _j.trim()) !== null && _k !== void 0 ? _k : "";
        if (friendWorkValue) {
            var lengthError = (0, phone_utils_1.getPhoneLengthError)(friendWorkPhone, "Friend work number");
            if (lengthError) {
                newErrors.friendWorkPhone = lengthError;
            }
        }
        // Log validation results
        if (Object.keys(newErrors).length > 0) {
            console.error("❌ Family & Friend Contacts validation errors:", newErrors);
        }
        else {
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    var validateHRDetailsStep = function () {
        var _a, _b;
        var newErrors = {};
        // Paymaster phone validation (optional but validate format if provided)
        var paymasterPhoneValue = (_a = payPointPhoneNumber === null || payPointPhoneNumber === void 0 ? void 0 : payPointPhoneNumber.phone_number) === null || _a === void 0 ? void 0 : _a.trim();
        if (paymasterPhoneValue) {
            var lengthError = (0, phone_utils_1.getPhoneLengthError)(payPointPhoneNumber, "Paymaster phone number");
            if (lengthError) {
                newErrors.paymasterPhoneNumber = lengthError;
            }
        }
        // HR Name (required)
        if (!(hrName === null || hrName === void 0 ? void 0 : hrName.trim())) {
            newErrors.hrName = validation_messages_1.HR_DETAILS_ERRORS.HR_NAME_REQUIRED;
        }
        // HR Phone Number (required)
        var hrPhoneValue = (_b = hrPhoneNumber === null || hrPhoneNumber === void 0 ? void 0 : hrPhoneNumber.phone_number) === null || _b === void 0 ? void 0 : _b.trim();
        if (!hrPhoneValue) {
            newErrors.hrPhoneNumber = validation_messages_1.HR_DETAILS_ERRORS.HR_PHONE_REQUIRED;
        }
        else {
            var lengthError = (0, phone_utils_1.getPhoneLengthError)(hrPhoneNumber, "HR phone number");
            if (lengthError) {
                newErrors.hrPhoneNumber = lengthError;
            }
        }
        // HR Postal Address (required)
        if (!(payPointPostalAddress === null || payPointPostalAddress === void 0 ? void 0 : payPointPostalAddress.trim())) {
            newErrors.hrPostalAddress = validation_messages_1.HR_DETAILS_ERRORS.HR_POSTAL_ADDRESS_REQUIRED;
        }
        // Postal Code (required)
        if (!(postalCode === null || postalCode === void 0 ? void 0 : postalCode.trim())) {
            newErrors.postalCode = validation_messages_1.HR_DETAILS_ERRORS.HR_POSTAL_CODE_REQUIRED;
        }
        // HR Physical Address (required)
        if (!(payPointPhysicalAddress === null || payPointPhysicalAddress === void 0 ? void 0 : payPointPhysicalAddress.trim())) {
            newErrors.hrPhysicalAddress =
                validation_messages_1.HR_DETAILS_ERRORS.HR_PHYSICAL_ADDRESS_REQUIRED;
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    var validateSalaryBankingStep = function () {
        var newErrors = {};
        // Bank (required)
        if (!(selectedBank === null || selectedBank === void 0 ? void 0 : selectedBank.trim())) {
            newErrors.bank = "Please select your bank";
        }
        // Branch (required)
        if (!(bankBranch === null || bankBranch === void 0 ? void 0 : bankBranch.trim())) {
            newErrors.branch = "Please enter branch name or code";
        }
        // Account Number (required)
        if (!(accountNumber === null || accountNumber === void 0 ? void 0 : accountNumber.trim())) {
            newErrors.accountNumber = "Please enter your account number";
        }
        // Account Type (required)
        if (!(accountType === null || accountType === void 0 ? void 0 : accountType.trim())) {
            newErrors.accountType = "Please select account type";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    var validateReviewStep = function () {
        var newErrors = {};
        if (!confirmationChecked) {
            newErrors.confirmation =
                "Please confirm that all information provided is accurate and complete";
        }
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    // Helper functions for dynamic fields
    var addAccountPayment = function () {
        var newId = Date.now().toString();
        setAccountPayments(__spreadArray(__spreadArray([], accountPayments, true), [
            { id: newId, description: "", amount: "0.00" }, // Client update: new account payments start at zero.
        ], false));
    };
    var removeAccountPayment = function (id) {
        setAccountPayments(accountPayments.filter(function (payment) { return payment.id !== id; }));
    };
    var updateAccountPayment = function (id, field, value) {
        setAccountPayments(accountPayments.map(function (payment) {
            var _a;
            return payment.id === id ? __assign(__assign({}, payment), (_a = {}, _a[field] = value, _a)) : payment;
        }));
    };
    var addFixedDeduction = function () {
        var newId = Date.now().toString();
        setFixedDeductions(__spreadArray(__spreadArray([], fixedDeductions, true), [
            { id: newId, description: "", amount: "0.00" }, // Client update: new deductions start at zero.
        ], false));
    };
    var removeFixedDeduction = function (id) {
        setFixedDeductions(fixedDeductions.filter(function (deduction) { return deduction.id !== id; }));
    };
    var updateFixedDeduction = function (id, field, value) {
        setFixedDeductions(fixedDeductions.map(function (deduction) {
            var _a;
            return deduction.id === id ? __assign(__assign({}, deduction), (_a = {}, _a[field] = value, _a)) : deduction;
        }));
    };
    var addOtherObligation = function () {
        var newId = Date.now().toString();
        setOtherObligations(__spreadArray(__spreadArray([], otherObligations, true), [
            { id: newId, description: "", amount: "0.00" }, // Client update: new obligations start at zero.
        ], false));
    };
    var removeOtherObligation = function (id) {
        setOtherObligations(otherObligations.filter(function (obligation) { return obligation.id !== id; }));
    };
    var updateOtherObligation = function (id, field, value) {
        setOtherObligations(otherObligations.map(function (obligation) {
            var _a;
            return obligation.id === id ? __assign(__assign({}, obligation), (_a = {}, _a[field] = value, _a)) : obligation;
        }));
    };
    var generateSalaryDeductionPDF = function () {
        // Create the PDF content as an HTML string
        var pdfContent = "\n      <!DOCTYPE html>\n      <html>\n        <head>\n          <title>Authorization for Salary Deduction</title>\n          <style>\n            body { font-family: Arial, sans-serif; margin: 40px; line-height: 1.6; }\n            .header { text-align: center; margin-bottom: 30px; }\n            .section { margin-bottom: 25px; }\n            .field { margin-bottom: 15px; }\n            .field-label { font-weight: bold; display: inline-block; width: 200px; }\n            .field-value { display: inline-block; border-bottom: 1px solid #000; min-width: 200px; padding-bottom: 2px; }\n            .declaration { background: #f5f5f5; padding: 20px; margin: 20px 0; }\n            .signature-section { margin-top: 50px; }\n            .signature-line { border-bottom: 1px solid #000; width: 300px; margin: 20px 0; }\n          </style>\n        </head>\n        <body>\n          <div class=\"header\">\n            <h1>AUTHORIZATION FOR SALARY DEDUCTION</h1>\n          </div>\n\n          <div class=\"section\">\n            <h3>Employee Information</h3>\n            <div class=\"field\">\n              <span class=\"field-label\">Pay Frequency:</span>\n              <span class=\"field-value\">".concat(payFrequency || "_______", "</span>\n            </div>\n            <div class=\"field\">\n              <span class=\"field-label\">Pay Date:</span>\n              <span class=\"field-value\">").concat(payDate || "_______", "</span>\n            </div>\n            <div class=\"field\">\n              <span class=\"field-label\">Employee Name:</span>\n              <span class=\"field-value\">").concat(employeeName || "_______", "</span>\n            </div>\n            <div class=\"field\">\n              <span class=\"field-label\">Employee Surname:</span>\n              <span class=\"field-value\">").concat(employeeSurname || "_______", "</span>\n            </div>\n            <div class=\"field\">\n              <span class=\"field-label\">Employee ID Number:</span>\n              <span class=\"field-value\">").concat(employeeIdNumber || "_______", "</span>\n            </div>\n            <div class=\"field\">\n              <span class=\"field-label\">Employee Phone Number:</span>\n              <span class=\"field-value\">").concat((employeePhoneNumber === null || employeePhoneNumber === void 0 ? void 0 : employeePhoneNumber.phone_number) || "_______", "</span>\n            </div>\n            <div class=\"field\">\n              <span class=\"field-label\">Force Number:</span>\n              <span class=\"field-value\">").concat(forceNumber || "Optional", "</span>\n            </div>\n          </div>\n\n          <div class=\"declaration\">\n            <h3>1. Hereby admit, confirm and declare that:</h3>\n            <p>I regard the availability of credit through the Salary Deduction Agreement concluded by my Employer with <strong>").concat(lender || "_______", "</strong> (hereinafter called THE LENDER), as an Employee Benefit provided by my Employer, and the resulting deductions as duly authorized in terms thereof;</p>\n            \n            <p><strong>1.1</strong> I am of the intent to obtain credit as an employee benefit from THE LENDER in terms of the said Salary Deduction Agreement, and that this authorization will be instrumental in the approval by THE LENDER of such credit;</p>\n            \n            <p><strong>1.2</strong> That I wish to make the payments towards above-mentioned credit by way of salary deductions by my employer</p>\n            \n            <p><strong>1.3</strong> That I wish my employer to assist me in every way possible to obtain this credit and facilitate the said payments by way of salary deductions.</p>\n\n            <h3>2. Therefore, I irrevocably order and authorize my present employer,</h3>\n            <p><strong>").concat(yourEmployer || "_______", "</strong> (NAME OF EMPLOYER AS ON PAYSLIP) as well as all of my future employers:</p>\n            \n            <p><strong>2.1</strong> To deduct the installment amounts as intimated by THE LENDER to my employer at the time in the amounts as requested by THE LENDER from my next salary/retainers and/or any other amounts payable to me, and pay the said amounts over without delay to THE LENDER.</p>\n            \n            <p><strong>2.2</strong> To provide THE LENDER now and in future, with all required information regarding my person, including personal, financial, employment, banking and credit information;</p>\n          </div>\n\n          <div class=\"signature-section\">\n            <div class=\"field\">\n              <span class=\"field-label\">Date:</span>\n              <span class=\"field-value\">").concat(new Date().toLocaleDateString(), "</span>\n            </div>\n            <br><br>\n            <div class=\"signature-line\"></div>\n            <p>Employee Signature</p>\n            <br>\n            <div class=\"signature-line\"></div>\n            <p>Print Name: ").concat(employeeName, " ").concat(employeeSurname, "</p>\n          </div>\n        </body>\n      </html>\n    ");
        // Create a new window and write the content
        var printWindow = window.open("", "_blank");
        if (printWindow) {
            printWindow.document.write(pdfContent);
            printWindow.document.close();
            // Wait for the content to load, then trigger print
            printWindow.onload = function () {
                printWindow.print();
                // Close the window after printing (user can cancel this)
                printWindow.onafterprint = function () {
                    printWindow.close();
                };
            };
        }
        else {
            alert("Please allow popups to download the PDF");
        }
    };
    var saveSignature = function () { return __awaiter(void 0, void 0, void 0, function () {
        var signatureDataURL, base64Content, byteCharacters, byteNumbers, i, byteArray, filename, file, url, error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!signatureRef.current || signatureRef.current.isEmpty()) {
                        setSignatureError("Please provide a signature");
                        return [2 /*return*/];
                    }
                    setIsSavingSignature(true);
                    setSignatureError("");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    signatureDataURL = signatureRef.current
                        .getTrimmedCanvas()
                        .toDataURL("image/png");
                    base64Content = signatureDataURL.split(",")[1];
                    byteCharacters = atob(base64Content);
                    byteNumbers = new Array(byteCharacters.length);
                    for (i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    byteArray = new Uint8Array(byteNumbers);
                    filename = "salary_deduction_signature_".concat(Math.random().toString(36).substring(2, 10).toUpperCase(), ".png");
                    file = new File([byteArray], filename, { type: "image/png" });
                    return [4 /*yield*/, (0, firebase_file_upload_1.uploadFileToFirebase)(file)];
                case 2:
                    url = _a.sent();
                    setSignatureURL(url);
                    setSignedDocumentUrl(url); // Update the signed document URL for form submission
                    setErrors(function (prev) {
                        if (!prev.signedDocumentUrl) {
                            return prev;
                        }
                        var _removed = prev.signedDocumentUrl, rest = __rest(prev, ["signedDocumentUrl"]);
                        return rest;
                    });
                    return [3 /*break*/, 4];
                case 3:
                    error_2 = _a.sent();
                    console.error("Error saving signature:", error_2);
                    setSignatureError("Failed to save signature. Please try again.");
                    return [3 /*break*/, 4];
                case 4:
                    setIsSavingSignature(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var clearSignature = function () {
        if (signatureRef.current) {
            signatureRef.current.clear();
        }
        setSignatureURL("");
        setSignedDocumentUrl("");
        setSignatureError("");
    };
    var saveBankSignature = function () { return __awaiter(void 0, void 0, void 0, function () {
        var dataURL, byteCharacters, byteNumbers, i, byteArray, filename, file, url, error_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!bankSignatureRef.current || bankSignatureRef.current.isEmpty()) {
                        setBankSignatureError("Please provide a signature before saving.");
                        return [2 /*return*/];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    setIsSavingBankSignature(true);
                    setBankSignatureError("");
                    dataURL = bankSignatureRef.current
                        .getTrimmedCanvas()
                        .toDataURL("image/png");
                    byteCharacters = atob(dataURL.split(",")[1]);
                    byteNumbers = new Array(byteCharacters.length);
                    for (i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    byteArray = new Uint8Array(byteNumbers);
                    filename = "bank_debit_signature_".concat(Math.random().toString(36).substring(2, 10).toUpperCase(), ".png");
                    file = new File([byteArray], filename, { type: "image/png" });
                    return [4 /*yield*/, (0, firebase_file_upload_1.uploadFileToFirebase)(file)];
                case 2:
                    url = _a.sent();
                    setBankSignatureURL(url);
                    setErrors(function (prev) {
                        if (!prev.bankSignatureURL) {
                            return prev;
                        }
                        var _removed = prev.bankSignatureURL, rest = __rest(prev, ["bankSignatureURL"]);
                        return rest;
                    });
                    return [3 /*break*/, 5];
                case 3:
                    error_3 = _a.sent();
                    console.error("Error saving bank signature:", error_3);
                    setBankSignatureError("An error occurred while saving the signature.");
                    return [3 /*break*/, 5];
                case 4:
                    setIsSavingBankSignature(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var clearBankSignature = function () {
        if (bankSignatureRef.current) {
            bankSignatureRef.current.clear();
        }
        setBankSignatureURL("");
        setBankSignatureError("");
    };
    var scrollToTop = function () {
        // Use setTimeout to ensure React has finished re-rendering the new step content
        setTimeout(function () {
            var contentElement = document.querySelector("[data-modal-content]");
            if (contentElement) {
                // Use instant scroll to avoid visible scroll animation when changing steps
                contentElement.scrollTo({ top: 0, behavior: "instant" });
            }
            // Also scroll the window/body in case the modal uses window scroll
            window.scrollTo({ top: 0, behavior: "instant" });
        }, 0);
    };
    /**
     * Clear completion flag for a step when user navigates backwards
     * This ensures resume logic returns user to the step they were on, not the furthest completed step
     * Exception: KYC completion is never cleared (permanent once verified)
     */
    var clearCompletionFlagForStep = function (step) { return __awaiter(void 0, void 0, void 0, function () {
        var flagName, updateData, appId, error_4;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    // Never clear KYC completion - it's permanent once verified
                    if (step === step_constants_1.STEP_KYC) {
                        return [2 /*return*/];
                    }
                    flagName = STEP_COMPLETION_FLAGS[step];
                    if (!flagName) {
                        return [2 /*return*/];
                    }
                    updateData = (_a = {},
                        _a[flagName] = false,
                        _a);
                    // Special case: Family contacts step has TWO completion flags
                    if (step === step_constants_1.STEP_FAMILY_CONTACTS) {
                        updateData.friend_complete = false;
                    }
                    appId = currentApplicationIdRef.current;
                    if (!appId) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, (0, application_1.updateLoanApplication)(__assign({ uid: appId }, updateData))];
                case 2:
                    _b.sent();
                    return [3 /*break*/, 4];
                case 3:
                    error_4 = _b.sent();
                    console.error("Failed to clear completion flag in Firestore:", error_4);
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    var handleBack = function () { return __awaiter(void 0, void 0, void 0, function () {
        var prevStep;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(currentStep > step_constants_1.STEP_START)) return [3 /*break*/, 2];
                    prevStep = currentStep - 1;
                    // CRITICAL: Set manual navigation flag BEFORE any async operations or state changes
                    // This prevents auto-skip logic from firing during re-renders caused by async operations
                    isManualNavigationRef.current = true;
                    // Clear validation state when navigating back
                    setValidationMessage("");
                    setErrors({});
                    // Clear completion flag for CURRENT step before moving back
                    // This ensures resume logic returns user to the step they were on, not the furthest completed
                    return [4 /*yield*/, clearCompletionFlagForStep(currentStep)];
                case 1:
                    // Clear completion flag for CURRENT step before moving back
                    // This ensures resume logic returns user to the step they were on, not the furthest completed
                    _a.sent();
                    setCurrentStep(prevStep);
                    scrollToTop();
                    // Reset manual navigation flag after a longer delay to ensure all effects complete
                    // This prevents auto-skip logic from firing after user manually navigates back
                    setTimeout(function () {
                        isManualNavigationRef.current = false;
                    }, 1500);
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleContinue = function () { return __awaiter(void 0, void 0, void 0, function () {
        var validationErrors, isSumSubApproved, hasPersonalInfo, isSumSubApproved, isSumSubApproved, isValid, isValid, validationErrors, isValid, isValid, validationErrors, validationErrors, validationErrors, uploadedPayslipUrl, uploadedBankStatementsUrl, newBankStatementUrls, _i, salaryBankingDoc2_1, file, url, uploadError_1, newErrors, newErrors, validationErrors;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    // Clear any previous validation message
                    setValidationMessage("");
                    if (!(currentStep === step_constants_1.STEP_START)) return [3 /*break*/, 4];
                    validationErrors = (0, loan_application_validators_1.validateLoanDetails)(selectedBranch, loanTerm, loanAmount, LOAN_AMOUNT_LIMITS, currency_1.formatCurrencyDisplay, selectedProviderId);
                    setErrors(validationErrors);
                    if (!(Object.keys(validationErrors).length === 0)) return [3 /*break*/, 2];
                    isSumSubApproved = (0, user_state_1.isKycVerified)(user, firebaseUserProfile);
                    hasPersonalInfo = !!firebaseUserProfile &&
                        firebaseUserProfile.name &&
                        firebaseUserProfile.surname &&
                        firebaseUserProfile.id_number;
                    if (isSumSubApproved) {
                        // User already verified - skip KYC step
                        setKycCompleted(true);
                        setCurrentStep(step_constants_1.STEP_PERSONAL_DETAILS);
                    }
                    else {
                        // User needs KYC verification
                        setCurrentStep(step_constants_1.STEP_KYC);
                    }
                    return [4 /*yield*/, handleAutoSaveProgress(step_constants_1.STEP_START)];
                case 1:
                    _a.sent();
                    scrollToTop();
                    return [3 /*break*/, 3];
                case 2:
                    console.error("❌ Loan Setup validation failed:", validationErrors);
                    setValidationMessage("Please complete all required fields before continuing.");
                    _a.label = 3;
                case 3: return [3 /*break*/, 60];
                case 4:
                    if (!(currentStep === step_constants_1.STEP_KYC)) return [3 /*break*/, 5];
                    isSumSubApproved = (0, user_state_1.isKycVerified)(user, firebaseUserProfile);
                    if (isSumSubApproved) {
                        // User already verified - proceed to Personal Details
                        setKycCompleted(true);
                        setCurrentStep(step_constants_1.STEP_PERSONAL_DETAILS);
                        scrollToTop();
                    }
                    else {
                        // User needs to verify - show message
                        setValidationMessage("Please complete identity verification before continuing.");
                    }
                    return [2 /*return*/];
                case 5:
                    if (!(currentStep === step_constants_1.STEP_PERSONAL_DETAILS)) return [3 /*break*/, 9];
                    isSumSubApproved = (0, user_state_1.isKycVerified)(user, firebaseUserProfile);
                    if (!isSumSubApproved) {
                        setValidationMessage("Please complete identity verification before continuing.");
                        setCurrentStep(step_constants_1.STEP_KYC);
                        scrollToTop();
                        return [2 /*return*/];
                    }
                    isValid = validatePersonalStep();
                    if (!isValid) return [3 /*break*/, 7];
                    setCurrentStep(step_constants_1.STEP_FAMILY_CONTACTS); // Go to Step 3 (Family & Friend)
                    return [4 /*yield*/, handleAutoSaveProgress(step_constants_1.STEP_PERSONAL_DETAILS)];
                case 6:
                    _a.sent();
                    scrollToTop();
                    return [3 /*break*/, 8];
                case 7:
                    // Log validation errors to help debug
                    console.error("❌ Personal Details validation failed. Checking errors state...");
                    // Errors are set in validatePersonalStep via setErrors, so check after a brief delay
                    setTimeout(function () {
                        console.error("📋 Current validation errors:", errors);
                    }, 100);
                    setValidationMessage("Please complete all required fields before continuing.");
                    _a.label = 8;
                case 8: return [3 /*break*/, 60];
                case 9:
                    if (!(currentStep === step_constants_1.STEP_FAMILY_CONTACTS)) return [3 /*break*/, 13];
                    isValid = validateFamilyContactsStep();
                    if (!isValid) return [3 /*break*/, 11];
                    setCurrentStep(step_constants_1.STEP_EMPLOYMENT); // Go to Step 4 (Employment)
                    return [4 /*yield*/, handleAutoSaveProgress(step_constants_1.STEP_FAMILY_CONTACTS)];
                case 10:
                    _a.sent();
                    scrollToTop();
                    return [3 /*break*/, 12];
                case 11:
                    console.error("❌ Family & Friend Contacts validation failed");
                    setValidationMessage("Please complete all required fields before continuing.");
                    _a.label = 12;
                case 12: return [3 /*break*/, 60];
                case 13:
                    if (!(currentStep === step_constants_1.STEP_EMPLOYMENT)) return [3 /*break*/, 17];
                    validationErrors = (0, loan_application_validators_1.validateEmploymentDetails)(employmentStatus, monthlyIncome, employer, supervisorName, workNumber, departmentNumber, workplaceAddress, employeeNumber, appointmentDate);
                    setErrors(validationErrors);
                    if (!(Object.keys(validationErrors).length === 0)) return [3 /*break*/, 15];
                    setCurrentStep(step_constants_1.STEP_HR_DETAILS); // Go to Step 5 (HR Details)
                    return [4 /*yield*/, handleAutoSaveProgress(step_constants_1.STEP_EMPLOYMENT)];
                case 14:
                    _a.sent();
                    scrollToTop();
                    return [3 /*break*/, 16];
                case 15:
                    console.error("❌ Employment Details validation failed");
                    setValidationMessage("Please complete all required fields before continuing.");
                    _a.label = 16;
                case 16: return [3 /*break*/, 60];
                case 17:
                    if (!(currentStep === step_constants_1.STEP_HR_DETAILS)) return [3 /*break*/, 21];
                    isValid = validateHRDetailsStep();
                    if (!isValid) return [3 /*break*/, 19];
                    setCurrentStep(step_constants_1.STEP_SALARY_BANKING); // Go to Step 6 (Salary Banking)
                    return [4 /*yield*/, handleAutoSaveProgress(step_constants_1.STEP_HR_DETAILS)];
                case 18:
                    _a.sent();
                    scrollToTop();
                    return [3 /*break*/, 20];
                case 19:
                    console.error("❌ HR Details validation failed");
                    setValidationMessage("Please fix the errors highlighted above before continuing.");
                    _a.label = 20;
                case 20: return [3 /*break*/, 60];
                case 21:
                    if (!(currentStep === step_constants_1.STEP_SALARY_BANKING)) return [3 /*break*/, 25];
                    isValid = validateSalaryBankingStep();
                    if (!isValid) return [3 /*break*/, 23];
                    setCurrentStep(STEP_LOAN_AFFORDABILITY); // Go to Step 7 (Loan Affordability)
                    return [4 /*yield*/, handleAutoSaveProgress(step_constants_1.STEP_SALARY_BANKING)];
                case 22:
                    _a.sent();
                    scrollToTop();
                    return [3 /*break*/, 24];
                case 23:
                    console.error("❌ Salary Banking validation failed");
                    setValidationMessage("Please complete all required fields before continuing.");
                    _a.label = 24;
                case 24: return [3 /*break*/, 60];
                case 25:
                    if (!(currentStep === STEP_LOAN_AFFORDABILITY)) return [3 /*break*/, 29];
                    validationErrors = (0, loan_application_validators_1.validateLoanAffordabilityStep)(selectedBranch, loanTerm, loanAmount, LOAN_AMOUNT_LIMITS, currency_1.formatCurrencyDisplay, housingExpense, transportExpense, educationExpense, electricityExpense, groceriesExpense, accountPayments, fixedDeductions, otherObligations, visibleExpenses, payFrequency, payDate);
                    Object.keys(validationErrors).forEach(function (key) { });
                    setErrors(validationErrors);
                    if (!(Object.keys(validationErrors).length === 0)) return [3 /*break*/, 27];
                    setCurrentStep(STEP_BANKING_DOCUMENTS);
                    return [4 /*yield*/, handleAutoSaveProgress(STEP_LOAN_AFFORDABILITY)];
                case 26:
                    _a.sent();
                    scrollToTop();
                    return [3 /*break*/, 28];
                case 27:
                    console.error("❌ Financial Details validation failed:", validationErrors);
                    console.error("📋 Number of errors:", Object.keys(validationErrors).length);
                    setValidationMessage("Please fix the errors highlighted above before continuing.");
                    _a.label = 28;
                case 28: return [3 /*break*/, 60];
                case 29:
                    if (!(currentStep === STEP_EMPLOYMENT_PAYPOINT)) return [3 /*break*/, 33];
                    validationErrors = (0, loan_application_validators_1.validateEmploymentPaypointStep)(employmentStatus, monthlyIncome, employer, supervisorName, workNumber, departmentNumber, workplaceAddress, employeeNumber, paymasterName, payPointPhoneNumber, payPointPostalAddress, postalCode, payPointPhysicalAddress, payDate);
                    setErrors(validationErrors);
                    if (!(Object.keys(validationErrors).length === 0)) return [3 /*break*/, 31];
                    setCurrentStep(STEP_BANKING_DOCUMENTS);
                    return [4 /*yield*/, handleAutoSaveProgress(STEP_EMPLOYMENT_PAYPOINT)];
                case 30:
                    _a.sent();
                    scrollToTop();
                    return [3 /*break*/, 32];
                case 31:
                    setValidationMessage("Please fix the errors highlighted above before continuing.");
                    _a.label = 32;
                case 32: return [3 /*break*/, 60];
                case 33:
                    if (!(currentStep === STEP_BANKING_DOCUMENTS)) return [3 /*break*/, 48];
                    validationErrors = (0, loan_application_validators_1.validateDocuments)(salaryBankingDoc1, salaryBankingDoc2 || [], latestPayslipUrl, bankStatementsUrl);
                    setErrors(validationErrors);
                    if (!(Object.keys(validationErrors).length === 0)) return [3 /*break*/, 46];
                    // Upload documents immediately to preserve them
                    setIsSubmitting(true);
                    _a.label = 34;
                case 34:
                    _a.trys.push([34, 43, 44, 45]);
                    uploadedPayslipUrl = latestPayslipUrl;
                    uploadedBankStatementsUrl = __spreadArray([], bankStatementsUrl, true);
                    if (!salaryBankingDoc1) return [3 /*break*/, 36];
                    return [4 /*yield*/, (0, firebase_file_upload_1.uploadFileToFirebase)(salaryBankingDoc1)];
                case 35:
                    uploadedPayslipUrl = _a.sent();
                    setLatestPayslipUrl(uploadedPayslipUrl);
                    _a.label = 36;
                case 36:
                    if (!(salaryBankingDoc2.length > 0)) return [3 /*break*/, 41];
                    newBankStatementUrls = [];
                    _i = 0, salaryBankingDoc2_1 = salaryBankingDoc2;
                    _a.label = 37;
                case 37:
                    if (!(_i < salaryBankingDoc2_1.length)) return [3 /*break*/, 40];
                    file = salaryBankingDoc2_1[_i];
                    return [4 /*yield*/, (0, firebase_file_upload_1.uploadFileToFirebase)(file)];
                case 38:
                    url = _a.sent();
                    newBankStatementUrls.push(url);
                    _a.label = 39;
                case 39:
                    _i++;
                    return [3 /*break*/, 37];
                case 40:
                    uploadedBankStatementsUrl = newBankStatementUrls;
                    setBankStatementsUrl(uploadedBankStatementsUrl);
                    _a.label = 41;
                case 41:
                    // Proceed to next step
                    setCurrentStep(step_constants_1.STEP_AUTHORIZATION_SALARY); // Go to step 9 (Salary Deduction Authorization)
                    return [4 /*yield*/, handleAutoSaveProgress(STEP_BANKING_DOCUMENTS, {
                            latestPayslipUrl: uploadedPayslipUrl,
                            bankStatementsUrl: uploadedBankStatementsUrl,
                        })];
                case 42:
                    _a.sent();
                    scrollToTop();
                    return [3 /*break*/, 45];
                case 43:
                    uploadError_1 = _a.sent();
                    console.error("Error uploading documents:", uploadError_1);
                    setValidationMessage("Error uploading documents. Please try again.");
                    return [3 /*break*/, 45];
                case 44:
                    setIsSubmitting(false);
                    return [7 /*endfinally*/];
                case 45: return [3 /*break*/, 47];
                case 46:
                    setValidationMessage("Please upload at least one document (payslip or bank statement) before continuing.");
                    _a.label = 47;
                case 47: return [3 /*break*/, 60];
                case 48:
                    if (!(currentStep === step_constants_1.STEP_AUTHORIZATION_SALARY)) return [3 /*break*/, 52];
                    if (!!signatureURL) return [3 /*break*/, 49];
                    setErrors(__assign(__assign({}, errors), { salaryDeductionSignature: "Please provide your digital signature to continue" }));
                    setValidationMessage("Please provide your digital signature before continuing.");
                    // Scroll to signature field
                    setTimeout(function () {
                        var signatureElement = document.querySelector(".sigCanvas");
                        if (signatureElement) {
                            signatureElement.scrollIntoView({
                                behavior: "smooth",
                                block: "center",
                            });
                        }
                    }, 100);
                    return [3 /*break*/, 51];
                case 49:
                    newErrors = __assign({}, errors);
                    delete newErrors.salaryDeductionSignature;
                    setErrors(newErrors);
                    setCurrentStep(step_constants_1.STEP_AUTHORIZATION_ELECTRONIC); // Go to step 10
                    return [4 /*yield*/, handleAutoSaveProgress(step_constants_1.STEP_AUTHORIZATION_SALARY)];
                case 50:
                    _a.sent();
                    scrollToTop();
                    _a.label = 51;
                case 51: return [3 /*break*/, 60];
                case 52:
                    if (!(currentStep === step_constants_1.STEP_AUTHORIZATION_ELECTRONIC)) return [3 /*break*/, 57];
                    if (!!bankSignatureURL) return [3 /*break*/, 53];
                    setErrors(__assign(__assign({}, errors), { electronicPaymentsSignature: "Please provide your digital signature to continue" }));
                    setValidationMessage("Please provide your digital signature before continuing.");
                    // Scroll to signature field
                    setTimeout(function () {
                        var signatureElement = document.querySelector(".sigCanvas");
                        if (signatureElement) {
                            signatureElement.scrollIntoView({
                                behavior: "smooth",
                                block: "center",
                            });
                        }
                    }, 100);
                    return [3 /*break*/, 56];
                case 53:
                    newErrors = __assign({}, errors);
                    delete newErrors.electronicPaymentsSignature;
                    setErrors(newErrors);
                    // Save final step data as DRAFT
                    return [4 /*yield*/, handleAutoSaveProgress(step_constants_1.STEP_AUTHORIZATION_ELECTRONIC)];
                case 54:
                    // Save final step data as DRAFT
                    _a.sent();
                    // Submit application (changes status from DRAFT to AWAIT)
                    return [4 /*yield*/, handleSubmitApplication()];
                case 55:
                    // Submit application (changes status from DRAFT to AWAIT)
                    _a.sent();
                    // handleSubmitApplication sets currentStep to STEP_COMPLETE internally
                    scrollToTop();
                    _a.label = 56;
                case 56: return [3 /*break*/, 60];
                case 57:
                    if (!(currentStep === STEP_AGREEMENTS)) return [3 /*break*/, 60];
                    validationErrors = (0, loan_application_validators_1.validateAgreements)(bankSignatureURL, confirmationChecked, employmentStatus, lender, yourEmployer, signedDocumentUrl);
                    setErrors(validationErrors);
                    if (!(Object.keys(validationErrors).length === 0)) return [3 /*break*/, 59];
                    return [4 /*yield*/, handleSubmitApplication()];
                case 58:
                    _a.sent();
                    return [3 /*break*/, 60];
                case 59:
                    setValidationMessage("Please complete all agreements and confirmations before submitting.");
                    console.error("❌ Validation failed. Please check the form for errors.", validationErrors);
                    // Scroll to first error
                    scrollToTop();
                    _a.label = 60;
                case 60: return [2 /*return*/];
            }
        });
    }); };
    // KYC completion handlers
    var handleKYCComplete = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3;
        setKycCompleted(true);
        setKycError(null);
        // Pre-populate fields from Firebase user profile and auth data
        if (firebaseUserProfile) {
            // Personal Details
            setName((_a = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.name) !== null && _a !== void 0 ? _a : "");
            setSurname((_b = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.surname) !== null && _b !== void 0 ? _b : "");
            setIdNumber((_c = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.id_number) !== null && _c !== void 0 ? _c : "");
            // Normalize gender value (capitalize first letter to match dropdown: "Male"/"Female")
            if (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.gender) {
                var normalizedGender = ((_d = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.gender) === null || _d === void 0 ? void 0 : _d.charAt(0).toUpperCase()) +
                    ((_e = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.gender) === null || _e === void 0 ? void 0 : _e.slice(1).toLowerCase());
                setGender(normalizedGender);
            }
            setIsMarried((firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.is_married) === undefined
                ? null
                : firebaseUserProfile.is_married);
            setMarriageType(normalizeMarriageType(firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.marriage_type));
            // Spouse details
            if (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.spouse) {
                setSpouseName((_f = firebaseUserProfile.spouse.name) !== null && _f !== void 0 ? _f : "");
                setSpouseLastName((_g = firebaseUserProfile.spouse.surname) !== null && _g !== void 0 ? _g : "");
                var spouseCell = convertProfilePhoneToIPhone(firebaseUserProfile.spouse.cell_number);
                if (spouseCell) {
                    setSpousePhoneNumber(normalizePhoneForState(spouseCell));
                }
                var spouseHome = convertProfilePhoneToIPhone(firebaseUserProfile.spouse.home_number);
                if (spouseHome) {
                    setSpouseHomeNumber(normalizePhoneForState(spouseHome));
                }
                var spouseWork = convertProfilePhoneToIPhone(firebaseUserProfile.spouse.work_number);
                if (spouseWork) {
                    setSpouseWorkNumber(normalizePhoneForState(spouseWork));
                }
            }
            // Family member
            if (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.family_member) {
                setFamilyMemberName((_h = firebaseUserProfile.family_member.name) !== null && _h !== void 0 ? _h : "");
                setFamilyMemberSurname((_j = firebaseUserProfile.family_member.surname) !== null && _j !== void 0 ? _j : "");
                setFamilyMemberRelationship((_k = firebaseUserProfile.family_member.relationship) !== null && _k !== void 0 ? _k : "");
                var familyCell = convertProfilePhoneToIPhone(firebaseUserProfile.family_member.cell_number);
                if (familyCell) {
                    setFamilyMemberCellPhone(normalizePhoneForState(familyCell));
                }
                var familyHome = convertProfilePhoneToIPhone(firebaseUserProfile.family_member.home_number);
                if (familyHome) {
                    setFamilyMemberHomePhone(normalizePhoneForState(familyHome));
                }
                var familyWork = convertProfilePhoneToIPhone(firebaseUserProfile.family_member.work_number);
                if (familyWork) {
                    setFamilyMemberWorkPhone(normalizePhoneForState(familyWork));
                }
            }
            // Friend contact
            if (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.friend) {
                setFriendName((_l = firebaseUserProfile.friend.name) !== null && _l !== void 0 ? _l : "");
                setFriendSurname((_m = firebaseUserProfile.friend.surname) !== null && _m !== void 0 ? _m : "");
                var friendCell = convertProfilePhoneToIPhone(firebaseUserProfile.friend.cell_number);
                if (friendCell) {
                    setFriendCellPhone(normalizePhoneForState(friendCell));
                }
                var friendHome = convertProfilePhoneToIPhone(firebaseUserProfile.friend.home_number);
                if (friendHome) {
                    setFriendHomePhone(normalizePhoneForState(friendHome));
                }
                var friendWork = convertProfilePhoneToIPhone(firebaseUserProfile.friend.work_number);
                if (friendWork) {
                    setFriendWorkPhone(normalizePhoneForState(friendWork));
                }
            }
            // Phone number from auth
            if (user === null || user === void 0 ? void 0 : user.cell_number) {
                var countryAbbreviation = user.cell_number
                    .country_abbreviation ||
                    "NA";
                setEmployeePhoneNumber({
                    phone_number: (0, phone_utils_1.enforcePhoneNumberLength)(user.cell_number.phone_number, countryAbbreviation),
                    country_code: user.cell_number.country_code || "+264",
                    country_abbreviation: countryAbbreviation,
                });
            }
            // Address
            setHomeAddress((_o = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.home_address) !== null && _o !== void 0 ? _o : null);
            setPostalAddress((_p = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.postal_address) !== null && _p !== void 0 ? _p : "");
            // Employment Details — main employment step.
            // The useState initialisers already read these, but they run on first
            // render which can fire before firebaseUserProfile is loaded from
            // Redux. Re-seed here so the form prepopulates regardless of load
            // order. Mirrors the mapping the useState initialisers do.
            if (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.employment_details) {
                var emp = firebaseUserProfile.employment_details;
                setEmploymentStatus((_q = emp.employment_status) !== null && _q !== void 0 ? _q : "");
                setMonthlyIncome((_r = emp.monthly_income) !== null && _r !== void 0 ? _r : "");
                setEmployer((_s = emp.employer) !== null && _s !== void 0 ? _s : "");
                setSupervisorName((_t = emp.supervisor) !== null && _t !== void 0 ? _t : "");
                setDepartmentNumber((_u = emp.department) !== null && _u !== void 0 ? _u : "");
                setEmployeeNumber((_v = emp.employee_number) !== null && _v !== void 0 ? _v : "");
                setWorkplaceAddress((_w = emp.address) !== null && _w !== void 0 ? _w : "");
                if (emp.appointment_date) {
                    var date = emp.appointment_date;
                    var dateStr = "";
                    if (typeof date === "string") {
                        dateStr = date.split("T")[0];
                    }
                    else if (date instanceof Date) {
                        dateStr = date.toISOString().split("T")[0];
                    }
                    else if (typeof date === "object" && "toDate" in date) {
                        dateStr = date.toDate().toISOString().split("T")[0];
                    }
                    if (dateStr)
                        setAppointmentDate(dateStr);
                }
                var workPhone = convertProfilePhoneToIPhone(emp.work_number);
                if (workPhone) {
                    var normalized = normalizePhoneForState(workPhone);
                    setWorkNumber(normalized);
                    setEmployeePhoneNumber(normalized);
                }
            }
            // HR / Paypoint Details.
            // Sky Web stores HR Name as paymaster_number and HR Phone as
            // phone_number inside paypoint_details (see loan-data-mapper.ts:318-321).
            // Same defensive re-seed pattern as employment_details above.
            if (firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.paypoint_details) {
                var pp = firebaseUserProfile.paypoint_details;
                setHRName((_x = pp.paymaster_number) !== null && _x !== void 0 ? _x : "");
                var hrPhone = convertProfilePhoneToIPhone(pp.phone_number);
                if (hrPhone) {
                    setHRPhoneNumber(normalizePhoneForState(hrPhone));
                }
                setPayPointPhysicalAddress((_y = pp.physical_address) !== null && _y !== void 0 ? _y : "");
                setPayPointPostalAddress((_z = pp.postal_address) !== null && _z !== void 0 ? _z : "");
                setPostalCode((_0 = pp.postal_code) !== null && _0 !== void 0 ? _0 : "");
            }
            // Employment Details for Authorization section
            setEmployeeName((_1 = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.name) !== null && _1 !== void 0 ? _1 : "");
            setEmployeeSurname((_2 = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.surname) !== null && _2 !== void 0 ? _2 : "");
            setEmployeeIdNumber((_3 = firebaseUserProfile === null || firebaseUserProfile === void 0 ? void 0 : firebaseUserProfile.id_number) !== null && _3 !== void 0 ? _3 : "");
        }
        setCurrentStep(STEP_PERSONAL);
        scrollToTop();
    };
    var handleKYCError = function (error) {
        setKycError(error);
        setKycCompleted(false);
        // Optionally show error dialog
        dispatch((0, content_dialog_1.showContentDialogThunk)({
            header: "KYC Verification Error",
            content: "Identity verification failed: ".concat(error),
            closable: true,
        }));
    };
    // Removed handleSaveForLater - auto-save happens after each step via handleAutoSaveProgress
    var handleSubmitApplication = function () { return __awaiter(void 0, void 0, void 0, function () {
        var submissionSucceeded, latestPayslipUrl_1, bankStatementsUrl_1, _i, salaryBankingDoc2_2, file, url, formData_1, applicationData, submissionTimestamp, submissionPayload, logData, saveResult, applicationUid, _, payloadWithoutStatus, result, profileUpdate, cleanedUpdate, updateResult, profileError_1, error_5, error_6;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (isSubmittingRef.current) {
                        console.warn("Submission already in progress, ignoring duplicate call");
                        return [2 /*return*/];
                    }
                    isSubmittingRef.current = true;
                    submissionSucceeded = false;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 27, 28, 29]);
                    setIsSubmitting(true);
                    latestPayslipUrl_1 = "";
                    bankStatementsUrl_1 = [];
                    if (!salaryBankingDoc1) return [3 /*break*/, 3];
                    return [4 /*yield*/, (0, firebase_file_upload_1.uploadFileToFirebase)(salaryBankingDoc1)];
                case 2:
                    latestPayslipUrl_1 = _b.sent();
                    _b.label = 3;
                case 3:
                    if (!(salaryBankingDoc2.length > 0)) return [3 /*break*/, 7];
                    _i = 0, salaryBankingDoc2_2 = salaryBankingDoc2;
                    _b.label = 4;
                case 4:
                    if (!(_i < salaryBankingDoc2_2.length)) return [3 /*break*/, 7];
                    file = salaryBankingDoc2_2[_i];
                    return [4 /*yield*/, (0, firebase_file_upload_1.uploadFileToFirebase)(file)];
                case 5:
                    url = _b.sent();
                    bankStatementsUrl_1.push(url);
                    _b.label = 6;
                case 6:
                    _i++;
                    return [3 /*break*/, 4];
                case 7:
                    // Collect all form data and map to Sky Lifestyle structure
                    // Debug: Check user object and firebase_user_id
                    if (!(user === null || user === void 0 ? void 0 : user.firebase_user_id)) {
                        console.error("❌ WARNING: firebase_user_id is missing! User may not be properly authenticated through Sky Lifestyle.");
                    }
                    formData_1 = {
                        name: name,
                        surname: surname,
                        gender: gender,
                        marriageType: marriageType,
                        loanAmount: loanAmount,
                        loanTerm: loanTerm,
                        selectedBranch: selectedBranch,
                        homeAddress: homeAddress,
                        homeErf: homeErf,
                        homeAddressGeoPoint: homeAddressGeoPoint,
                        postalAddress: postalAddress,
                        idNumber: idNumber,
                        isMarried: isMarried,
                        spouseName: spouseName,
                        spouseLastName: spouseLastName,
                        spousePhoneNumber: spousePhoneNumber,
                        spouseHomeNumber: spouseHomeNumber,
                        spouseWorkNumber: spouseWorkNumber,
                        familyMemberName: familyMemberName,
                        familyMemberSurname: familyMemberSurname,
                        familyMemberRelationship: familyMemberRelationship,
                        familyMemberCellPhone: familyMemberCellPhone,
                        familyMemberWorkPhone: familyMemberWorkPhone,
                        familyMemberHomePhone: familyMemberHomePhone,
                        friendName: friendName,
                        friendSurname: friendSurname,
                        friendCellPhone: friendCellPhone,
                        friendWorkPhone: friendWorkPhone,
                        friendHomePhone: friendHomePhone,
                        employmentStatus: employmentStatus,
                        monthlyIncome: monthlyIncome,
                        employer: employer,
                        supervisorName: supervisorName,
                        departmentNumber: departmentNumber,
                        employeeNumber: employeeNumber,
                        workplaceAddress: workplaceAddress,
                        workplaceAddressGeoPoint: workplaceAddressGeoPoint,
                        workNumber: workNumber,
                        appointmentDate: appointmentDate,
                        housingExpense: housingExpense,
                        transportExpense: transportExpense,
                        educationExpense: educationExpense,
                        electricityExpense: electricityExpense,
                        groceriesExpense: groceriesExpense,
                        accountPayments: accountPayments,
                        fixedDeductions: fixedDeductions,
                        otherObligations: otherObligations,
                        payFrequency: payFrequency,
                        payDate: payDate,
                        paymasterName: paymasterName,
                        payPointPhoneNumber: payPointPhoneNumber,
                        payPointPostalAddress: payPointPostalAddress,
                        payPointPostalAddressGeoPoint: payPointPostalAddressGeoPoint,
                        payPointPhysicalAddress: payPointPhysicalAddress,
                        payPointPhysicalAddressGeoPoint: payPointPhysicalAddressGeoPoint,
                        postalCode: postalCode,
                        // HR fields — the mapper (loan-data-mapper.ts) writes
                        // paypoint_details from formData.hr* keys, but the form state for
                        // postal/physical lives on payPoint* vars (props are renamed when
                        // passed to HRDetailsStep). Without these aliases the UI displays
                        // populated HR fields while the save writes blanks.
                        hrName: hrName,
                        hrPhoneNumber: hrPhoneNumber,
                        hrPostalAddress: payPointPostalAddress,
                        hrPostalAddressGeoPoint: payPointPostalAddressGeoPoint,
                        hrPhysicalAddress: payPointPhysicalAddress,
                        hrPhysicalAddressGeoPoint: payPointPhysicalAddressGeoPoint,
                        selectedBank: selectedBank,
                        bankBranch: bankBranch,
                        accountNumber: accountNumber,
                        accountType: accountType,
                        signatureURL: signatureURL,
                        employeeName: employeeName,
                        employeeSurname: employeeSurname,
                        employeeIdNumber: employeeIdNumber,
                        employeePhoneNumber: employeePhoneNumber,
                        forceNumber: forceNumber,
                        lender: lender,
                        yourEmployer: yourEmployer,
                        signedDocumentUrl: signedDocumentUrl,
                        bankSignatureURL: bankSignatureURL,
                        confirmationChecked: confirmationChecked,
                        // Keep status as DRAFT during save - submitLoanApplication will change it to AWAIT
                        status: loan_application_1.APPLICATION_STATUS.DRAFT,
                        // Mark all 12 steps as complete for final submission
                        kyc_complete: true,
                        personal_complete: true,
                        family_complete: true,
                        friend_complete: true,
                        employment_complete: true,
                        paypoint_complete: true,
                        bankDetails_complete: true,
                        financial_complete: true,
                        docs_complete: true,
                        authoriseSalary_complete: true,
                        authoriseBank_complete: true,
                        agree_terms: true,
                        // Add user and provider references
                        // Always use Firebase localId for Firebase loan creation
                        userId: user === null || user === void 0 ? void 0 : user.firebase_user_id,
                        providerId: selectedProviderId, // Use selected provider ID from form
                        // Add uploaded document URLs
                        latestPayslipUrl: latestPayslipUrl_1,
                        bankStatementsUrl: bankStatementsUrl_1,
                    };
                    applicationData = (0, loan_data_mapper_1.mapFormDataToSkyLifestyle)(formData_1);
                    submissionTimestamp = new Date();
                    submissionPayload = __assign(__assign({}, applicationData), { date_completed: submissionTimestamp });
                    logData = __assign(__assign(__assign(__assign({}, submissionPayload), (submissionPayload.user && { user: "users/".concat(formData_1.userId) })), (submissionPayload.provider && {
                        provider: "providers/".concat(formData_1.providerId),
                    })), (submissionPayload.branch && {
                        branch: "branches/".concat(formData_1.selectedBranch),
                    }));
                    saveResult = void 0;
                    applicationUid = currentApplicationIdRef.current;
                    _ = submissionPayload.status, payloadWithoutStatus = __rest(submissionPayload, ["status"]);
                    if (!applicationUid) return [3 /*break*/, 9];
                    return [4 /*yield*/, (0, application_1.updateLoanApplication)(__assign({ uid: applicationUid }, payloadWithoutStatus))];
                case 8:
                    // Update existing application with all data (no status)
                    saveResult = _b.sent();
                    return [3 /*break*/, 11];
                case 9: return [4 /*yield*/, (0, application_1.createLoanApplication)(payloadWithoutStatus)];
                case 10:
                    // Create new application (status defaults to DRAFT in createLoanApplication)
                    saveResult = _b.sent();
                    if (saveResult.success && ((_a = saveResult.content) === null || _a === void 0 ? void 0 : _a.uid)) {
                        applicationUid = saveResult.content.uid;
                        setCurrentApplicationId(applicationUid);
                        currentApplicationIdRef.current = applicationUid;
                    }
                    _b.label = 11;
                case 11:
                    result = void 0;
                    if (!(saveResult.success && applicationUid)) return [3 /*break*/, 13];
                    return [4 /*yield*/, (0, application_1.submitLoanApplication)(applicationUid)];
                case 12:
                    result = _b.sent();
                    return [3 /*break*/, 14];
                case 13:
                    console.error("❌ Save failed, skipping submission. Save result:", saveResult);
                    result = saveResult; // Use save result if save failed
                    _b.label = 14;
                case 14:
                    if (!result.success) return [3 /*break*/, 25];
                    _b.label = 15;
                case 15:
                    _b.trys.push([15, 18, , 19]);
                    profileUpdate = buildProfileUpdatePayload();
                    cleanedUpdate = JSON.parse(JSON.stringify(profileUpdate));
                    if (!(Object.keys(cleanedUpdate).length > 0)) return [3 /*break*/, 17];
                    return [4 /*yield*/, updateProfile(cleanedUpdate).unwrap()];
                case 16:
                    updateResult = _b.sent();
                    _b.label = 17;
                case 17: return [3 /*break*/, 19];
                case 18:
                    profileError_1 = _b.sent();
                    console.error("Failed to update profile (non-critical):", profileError_1);
                    return [3 /*break*/, 19];
                case 19: return [4 /*yield*/, pushFirebaseUserUpdate()];
                case 20:
                    _b.sent();
                    // Navigate to Step 11 (Complete) and reset for next application
                    // Clear signatures (user must sign again for new application)
                    setSignatureURL("");
                    setBankSignatureURL("");
                    // Clear current application ID so new draft is created
                    setCurrentApplicationId(null);
                    currentApplicationIdRef.current = null;
                    _b.label = 21;
                case 21:
                    _b.trys.push([21, 23, , 24]);
                    return [4 /*yield*/, updateProfile({ pep_completed: false }).unwrap()];
                case 22:
                    _b.sent();
                    return [3 /*break*/, 24];
                case 23:
                    error_5 = _b.sent();
                    console.error("Failed to reset PEP/PIP completion status (non-critical):", error_5);
                    return [3 /*break*/, 24];
                case 24:
                    // Navigate to Complete step (Step 11)
                    submissionSucceeded = true;
                    setCurrentStep(step_constants_1.STEP_COMPLETE);
                    return [3 /*break*/, 26];
                case 25:
                    alert("Failed to submit application: ".concat(result.message));
                    _b.label = 26;
                case 26: return [3 /*break*/, 29];
                case 27:
                    error_6 = _b.sent();
                    console.error("Error submitting application:", error_6);
                    alert("Error submitting application. Please try again.");
                    return [3 /*break*/, 29];
                case 28:
                    setIsSubmitting(false);
                    isSubmittingRef.current = false;
                    if (pendingResetRef.current) {
                        pendingResetRef.current = false;
                        if (submissionSucceeded) {
                            // Modal was reopened during submission — safe to reset since draft was submitted
                            resetModalState();
                        }
                        // On failure: do NOT reset — draft still exists as DRAFT, keep IDs so autosave
                        // continues updating the same draft instead of creating a duplicate
                    }
                    return [7 /*endfinally*/];
                case 29: return [2 /*return*/];
            }
        });
    }); };
    var buildProfileUpdatePayload = function () {
        var isMarriedValue = typeof isMarried === "boolean" ? isMarried : undefined;
        var familyMemberPayload = familyMemberName ||
            familyMemberSurname ||
            familyMemberRelationship ||
            (familyMemberCellPhone === null || familyMemberCellPhone === void 0 ? void 0 : familyMemberCellPhone.phone_number) ||
            (familyMemberWorkPhone === null || familyMemberWorkPhone === void 0 ? void 0 : familyMemberWorkPhone.phone_number) ||
            (familyMemberHomePhone === null || familyMemberHomePhone === void 0 ? void 0 : familyMemberHomePhone.phone_number)
            ? {
                name: familyMemberName || undefined,
                surname: familyMemberSurname || undefined,
                relationship: familyMemberRelationship || undefined,
                cell_phone: (familyMemberCellPhone === null || familyMemberCellPhone === void 0 ? void 0 : familyMemberCellPhone.phone_number)
                    ? {
                        calling_code: familyMemberCellPhone.country_code,
                        country_code: familyMemberCellPhone.country_abbreviation,
                        number: familyMemberCellPhone.phone_number,
                    }
                    : undefined,
                work_phone: (familyMemberWorkPhone === null || familyMemberWorkPhone === void 0 ? void 0 : familyMemberWorkPhone.phone_number)
                    ? {
                        calling_code: familyMemberWorkPhone.country_code,
                        country_code: familyMemberWorkPhone.country_abbreviation,
                        number: familyMemberWorkPhone.phone_number,
                    }
                    : undefined,
                home_phone: (familyMemberHomePhone === null || familyMemberHomePhone === void 0 ? void 0 : familyMemberHomePhone.phone_number)
                    ? {
                        calling_code: familyMemberHomePhone.country_code,
                        country_code: familyMemberHomePhone.country_abbreviation,
                        number: familyMemberHomePhone.phone_number,
                    }
                    : undefined,
            }
            : undefined;
        var friendPayload = friendName ||
            friendSurname ||
            (friendCellPhone === null || friendCellPhone === void 0 ? void 0 : friendCellPhone.phone_number) ||
            (friendWorkPhone === null || friendWorkPhone === void 0 ? void 0 : friendWorkPhone.phone_number) ||
            (friendHomePhone === null || friendHomePhone === void 0 ? void 0 : friendHomePhone.phone_number)
            ? {
                name: friendName || undefined,
                surname: friendSurname || undefined,
                cell_phone: (friendCellPhone === null || friendCellPhone === void 0 ? void 0 : friendCellPhone.phone_number)
                    ? {
                        calling_code: friendCellPhone.country_code,
                        country_code: friendCellPhone.country_abbreviation,
                        number: friendCellPhone.phone_number,
                    }
                    : undefined,
                work_phone: (friendWorkPhone === null || friendWorkPhone === void 0 ? void 0 : friendWorkPhone.phone_number)
                    ? {
                        calling_code: friendWorkPhone.country_code,
                        country_code: friendWorkPhone.country_abbreviation,
                        number: friendWorkPhone.phone_number,
                    }
                    : undefined,
                home_phone: (friendHomePhone === null || friendHomePhone === void 0 ? void 0 : friendHomePhone.phone_number)
                    ? {
                        calling_code: friendHomePhone.country_code,
                        country_code: friendHomePhone.country_abbreviation,
                        number: friendHomePhone.phone_number,
                    }
                    : undefined,
                date_updated: new Date().toISOString(),
            }
            : undefined;
        var financialDetailBase = {
            housing: housingExpense || undefined,
            transport: transportExpense || undefined,
            education: educationExpense || undefined,
            electricity: electricityExpense || undefined,
            groceries_and_other: groceriesExpense || undefined,
            // Note: Backend expects "acccount_payments" (with typo) - see API validation
            acccount_payments: accountPayments.length > 0
                ? accountPayments.map(function (p) { return ({
                    key: p.description,
                    value: p.amount,
                }); })
                : undefined,
            fixed_monthly_deductions: fixedDeductions.length > 0
                ? fixedDeductions.map(function (d) { return ({
                    key: d.description,
                    value: d.amount,
                }); })
                : undefined,
            other_obligations: otherObligations.length > 0
                ? otherObligations.map(function (o) { return ({
                    key: o.description,
                    value: o.amount,
                }); })
                : undefined,
            payment_frequency: payFrequency ? payFrequency.toUpperCase() : undefined,
            preferred_payday: payDate || undefined,
        };
        var financialDetailHasValues = Object.values(financialDetailBase).some(function (value) {
            if (Array.isArray(value)) {
                return value && value.length > 0;
            }
            return value !== undefined;
        });
        var financialDetailPayload = financialDetailHasValues
            ? __assign(__assign({}, financialDetailBase), { date_updated: new Date().toISOString() }) : undefined;
        var paypointPayload = paymasterName ||
            payPointPostalAddress ||
            payPointPostalAddressGeoPoint ||
            payPointPhysicalAddress ||
            payPointPhysicalAddressGeoPoint ||
            (payPointPhoneNumber === null || payPointPhoneNumber === void 0 ? void 0 : payPointPhoneNumber.phone_number) ||
            postalCode
            ? {
                paymaster_number: paymasterName || undefined,
                phone_number: (payPointPhoneNumber === null || payPointPhoneNumber === void 0 ? void 0 : payPointPhoneNumber.phone_number)
                    ? {
                        phone_number: payPointPhoneNumber.phone_number,
                        country_code: payPointPhoneNumber.country_code,
                        country_abbreviation: payPointPhoneNumber.country_abbreviation,
                    }
                    : undefined,
                postal_address: payPointPostalAddress || undefined,
                postal_address_location: payPointPostalAddressGeoPoint || undefined,
                physical_address: payPointPhysicalAddress || undefined,
                physical_address_location: payPointPhysicalAddressGeoPoint || undefined,
                postal_code: postalCode || undefined,
            }
            : undefined;
        var hasSalaryBankInfo = Boolean(selectedBank || bankBranch || accountNumber || accountType);
        var profileSalaryBankPayload = hasSalaryBankInfo
            ? {
                bank: selectedBank || undefined,
                branch: bankBranch || undefined,
                account_number: accountNumber || undefined,
                account_type: accountType || undefined,
                date_updated: new Date().toISOString(),
            }
            : undefined;
        return {
            // Basic profile fields
            postal_code: postalCode || undefined,
            address: (homeAddress === null || homeAddress === void 0 ? void 0 : homeAddress.full_address) || undefined,
            id_number: idNumber || undefined,
            cell_phone: (employeePhoneNumber === null || employeePhoneNumber === void 0 ? void 0 : employeePhoneNumber.phone_number)
                ? {
                    calling_code: employeePhoneNumber.country_code,
                    country_code: employeePhoneNumber.country_abbreviation,
                    number: employeePhoneNumber.phone_number,
                }
                : undefined,
            // Basic personal details
            firstName: name || undefined,
            lastName: surname || undefined,
            gender: gender || undefined,
            isMarried: isMarriedValue,
            marriageType: marriageType || undefined,
            is_married: isMarriedValue,
            marriage_type: marriageType || undefined,
            // Home address with Erf
            home_address: (homeAddress === null || homeAddress === void 0 ? void 0 : homeAddress.full_address) ||
                (homeAddress === null || homeAddress === void 0 ? void 0 : homeAddress.homeErf) ||
                homeErf ||
                homeAddressGeoPoint
                ? {
                    full_address: (homeAddress === null || homeAddress === void 0 ? void 0 : homeAddress.full_address) || undefined,
                    homeErf: homeErf || (homeAddress === null || homeAddress === void 0 ? void 0 : homeAddress.homeErf) || undefined,
                    location: homeAddressGeoPoint || (homeAddress === null || homeAddress === void 0 ? void 0 : homeAddress.location) || undefined,
                }
                : undefined,
            postal_address: postalAddress || undefined,
            // Spouse information (backend validation excludes home_number)
            spouse: isMarriedValue
                ? {
                    name: spouseName || undefined,
                    surname: spouseLastName || undefined,
                    cell_number: (spousePhoneNumber === null || spousePhoneNumber === void 0 ? void 0 : spousePhoneNumber.phone_number)
                        ? {
                            phone_number: spousePhoneNumber.phone_number,
                            country_code: spousePhoneNumber.country_code,
                            country_abbreviation: spousePhoneNumber.country_abbreviation,
                        }
                        : undefined,
                    work_number: (spouseWorkNumber === null || spouseWorkNumber === void 0 ? void 0 : spouseWorkNumber.phone_number)
                        ? {
                            phone_number: spouseWorkNumber.phone_number,
                            country_code: spouseWorkNumber.country_code,
                            country_abbreviation: spouseWorkNumber.country_abbreviation,
                        }
                        : undefined,
                    relationship: "SPOUSE",
                }
                : undefined,
            // Employment details
            employment_details: employmentStatus ||
                monthlyIncome ||
                employer ||
                supervisorName ||
                departmentNumber ||
                appointmentDate ||
                employeeNumber ||
                workplaceAddress ||
                (workNumber === null || workNumber === void 0 ? void 0 : workNumber.phone_number)
                ? {
                    employment_status: employmentStatus || undefined,
                    monthly_income: monthlyIncome || undefined,
                    employer: employer || undefined,
                    supervisor: supervisorName || undefined,
                    department: departmentNumber || undefined,
                    employee_number: employeeNumber || undefined,
                    appointment_date: appointmentDate
                        ? new Date(appointmentDate).toISOString()
                        : undefined,
                    address: workplaceAddress || undefined,
                    address_location: workplaceAddressGeoPoint || undefined,
                    work_number: (workNumber === null || workNumber === void 0 ? void 0 : workNumber.phone_number)
                        ? {
                            phone_number: workNumber.phone_number,
                            country_code: workNumber.country_code,
                            country_abbreviation: workNumber.country_abbreviation,
                        }
                        : undefined,
                }
                : undefined,
            // Financial details
            financial_detail: financialDetailPayload,
            // Paypoint details
            paypoint_details: paypointPayload,
            // User profiles use salary_bank in both Mongo and Firebase. Loan
            // documents use salary_bank_details through mapFormDataToSkyLifestyle.
            salary_bank: profileSalaryBankPayload,
            // Family member and friend
            family_member: familyMemberPayload,
            friend: friendPayload,
        };
    };
    var mapPhoneToNumberObject = function (phone) {
        if (!phone || !phone.phone_number) {
            return undefined;
        }
        return {
            phone_number: phone.phone_number,
            country_code: phone.country_code,
            country_abbreviation: phone.country_abbreviation,
        };
    };
    var mapPhoneToCallingCode = function (phone) {
        if (!phone || !phone.phone_number) {
            return undefined;
        }
        return {
            calling_code: phone.country_code,
            country_code: phone.country_abbreviation,
            number: phone.phone_number,
        };
    };
    var buildFirebaseUserUpdate = function () {
        var resolvedHomeAddress = homeAddress === null || homeAddress === void 0 ? void 0 : homeAddress.full_address;
        var resolvedHomeErf = homeErf || (homeAddress === null || homeAddress === void 0 ? void 0 : homeAddress.homeErf);
        var resolvedHomeLocation = homeAddressGeoPoint || (homeAddress === null || homeAddress === void 0 ? void 0 : homeAddress.location) || null;
        var homeAddressData = resolvedHomeAddress || resolvedHomeErf || resolvedHomeLocation
            ? __assign({ full_address: resolvedHomeAddress || undefined, homeErf: resolvedHomeErf || undefined }, (resolvedHomeLocation ? { location: resolvedHomeLocation } : {})) : undefined;
        var employmentDetails = employmentStatus ||
            monthlyIncome ||
            employer ||
            supervisorName ||
            departmentNumber ||
            appointmentDate ||
            employeeNumber ||
            workplaceAddress ||
            (workNumber === null || workNumber === void 0 ? void 0 : workNumber.phone_number)
            ? __assign(__assign({ employment_status: employmentStatus || undefined, monthly_income: monthlyIncome || undefined, employer: employer || undefined, supervisor: supervisorName || undefined, department: departmentNumber || undefined, employee_number: employeeNumber || undefined, appointment_date: appointmentDate
                    ? new Date(appointmentDate)
                    : undefined, address: workplaceAddress || undefined }, (workplaceAddressGeoPoint && {
                address_location: workplaceAddressGeoPoint,
            })), { work_number: mapPhoneToNumberObject(workNumber) }) : undefined;
        var spouseData = isMarried && isMarried === true
            ? {
                name: spouseName || undefined,
                surname: spouseLastName || undefined,
                cell_number: mapPhoneToNumberObject(spousePhoneNumber),
                home_number: mapPhoneToNumberObject(spouseHomeNumber),
                work_number: mapPhoneToNumberObject(spouseWorkNumber),
                date_updated: firestore_1.Timestamp.now(),
            }
            : undefined;
        var familyMemberData = familyMemberName ||
            familyMemberSurname ||
            familyMemberRelationship ||
            (familyMemberCellPhone === null || familyMemberCellPhone === void 0 ? void 0 : familyMemberCellPhone.phone_number) ||
            (familyMemberWorkPhone === null || familyMemberWorkPhone === void 0 ? void 0 : familyMemberWorkPhone.phone_number) ||
            (familyMemberHomePhone === null || familyMemberHomePhone === void 0 ? void 0 : familyMemberHomePhone.phone_number)
            ? {
                name: familyMemberName || undefined,
                surname: familyMemberSurname || undefined,
                relationship: familyMemberRelationship || undefined,
                cell_number: mapPhoneToCallingCode(familyMemberCellPhone),
                work_number: mapPhoneToCallingCode(familyMemberWorkPhone),
                home_number: mapPhoneToCallingCode(familyMemberHomePhone),
            }
            : undefined;
        var friendData = friendName ||
            friendSurname ||
            (friendCellPhone === null || friendCellPhone === void 0 ? void 0 : friendCellPhone.phone_number) ||
            (friendWorkPhone === null || friendWorkPhone === void 0 ? void 0 : friendWorkPhone.phone_number) ||
            (friendHomePhone === null || friendHomePhone === void 0 ? void 0 : friendHomePhone.phone_number)
            ? {
                name: friendName || undefined,
                surname: friendSurname || undefined,
                cell_number: mapPhoneToCallingCode(friendCellPhone),
                work_number: mapPhoneToCallingCode(friendWorkPhone),
                home_number: mapPhoneToCallingCode(friendHomePhone),
                date_updated: firestore_1.Timestamp.now(),
            }
            : undefined;
        var financialDetailBase = {
            housing: housingExpense || undefined,
            transport: transportExpense || undefined,
            education: educationExpense || undefined,
            electricity: electricityExpense || undefined,
            groceries_and_other: groceriesExpense || undefined,
            account_payments: accountPayments.length > 0
                ? accountPayments.map(function (payment) { return ({
                    key: payment.description,
                    value: payment.amount,
                }); })
                : undefined,
            fixed_monthly_deductions: fixedDeductions.length > 0
                ? fixedDeductions.map(function (deduction) { return ({
                    key: deduction.description,
                    value: deduction.amount,
                }); })
                : undefined,
            other_obligations: otherObligations.length > 0
                ? otherObligations.map(function (obligation) { return ({
                    key: obligation.description,
                    value: obligation.amount,
                }); })
                : undefined,
            payment_frequency: payFrequency ? payFrequency.toUpperCase() : undefined,
            preferred_payday: payDate || undefined,
        };
        var financialDetailHasValues = Object.values(financialDetailBase).some(function (value) {
            if (Array.isArray(value)) {
                return Array.isArray(value) && value.length > 0;
            }
            return value !== undefined;
        });
        var financialDetailData = financialDetailHasValues
            ? __assign(__assign({}, financialDetailBase), { date_updated: firestore_1.Timestamp.now() }) : undefined;
        var paypointDetailsData = paymasterName ||
            payPointPostalAddress ||
            payPointPostalAddressGeoPoint ||
            payPointPhysicalAddress ||
            payPointPhysicalAddressGeoPoint ||
            (payPointPhoneNumber === null || payPointPhoneNumber === void 0 ? void 0 : payPointPhoneNumber.phone_number) ||
            postalCode
            ? __assign(__assign(__assign(__assign({ paymaster_number: paymasterName || undefined, phone_number: mapPhoneToNumberObject(payPointPhoneNumber), postal_address: payPointPostalAddress || undefined }, (payPointPostalAddressGeoPoint && {
                postal_address_location: payPointPostalAddressGeoPoint,
            })), { physical_address: payPointPhysicalAddress || undefined }), (payPointPhysicalAddressGeoPoint && {
                physical_address_location: payPointPhysicalAddressGeoPoint,
            })), { postal_code: postalCode || undefined }) : undefined;
        var hasSalaryBankInfo = Boolean(selectedBank || bankBranch || accountNumber || accountType);
        var salaryBankData = hasSalaryBankInfo
            ? {
                bank: selectedBank || undefined,
                branch: bankBranch || undefined,
                account_number: accountNumber || undefined,
                account_type: accountType || undefined,
                date_updated: firestore_1.Timestamp.now(),
            }
            : undefined;
        // Gender: use as-is (should be "Male" or "Female" from dropdown)
        var normalizedGender = gender || undefined;
        // Marriage type: use as-is (should be "InCommunityOfProperty", "OutOfCommunityOfProperty", or "Traditional")
        var normalizedMarriageType = marriageType || undefined;
        return {
            name: name || undefined,
            surname: surname || undefined,
            id_number: idNumber || undefined,
            is_married: typeof isMarried === "boolean" ? Boolean(isMarried) : undefined,
            marriage_type: normalizedMarriageType,
            gender: normalizedGender,
            home_address: homeAddressData,
            postal_address: postalAddress || undefined,
            employment_details: employmentDetails,
            family_member: familyMemberData,
            spouse: spouseData,
            friend: friendData,
            financial_detail: financialDetailData,
            paypoint_details: paypointDetailsData,
            salary_bank: salaryBankData,
        };
    };
    var fetchAndSetFirebaseProfile = function (firebaseUid) { return __awaiter(void 0, void 0, void 0, function () {
        var profileResponse, error_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, (0, get_firebase_user_profile_1.get_firebase_user_profile)(firebaseUid)];
                case 1:
                    profileResponse = _a.sent();
                    if (profileResponse.success && profileResponse.content) {
                        // profileResponse.content has { raw, sanitized } - use sanitized for Redux
                        dispatch((0, user_profile_1.setFirebaseUserProfile)(profileResponse.content.sanitized));
                    }
                    return [3 /*break*/, 3];
                case 2:
                    error_7 = _a.sent();
                    console.error("Failed to refresh Firebase user profile:", error_7);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    function pushFirebaseUserUpdate() {
        return __awaiter(this, void 0, void 0, function () {
            var firebaseUid, firebaseUpdate, cleanedFirebaseUpdate, userDocRef, error_8;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        firebaseUid = resolveFirebaseUid();
                        if (!firebaseUid) {
                            console.warn("Unable to determine Firebase UID for profile sync");
                            return [2 /*return*/];
                        }
                        firebaseUpdate = buildFirebaseUserUpdate();
                        cleanedFirebaseUpdate = removeUndefinedDeep(firebaseUpdate);
                        if (!cleanedFirebaseUpdate ||
                            Object.keys(cleanedFirebaseUpdate).length === 0) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, , 5]);
                        userDocRef = (0, firestore_1.doc)(firebase_1.firestore, "users", firebaseUid);
                        return [4 /*yield*/, (0, firestore_1.setDoc)(userDocRef, cleanedFirebaseUpdate, { merge: true })];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, fetchAndSetFirebaseProfile(firebaseUid)];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 5];
                    case 4:
                        error_8 = _a.sent();
                        console.error("Failed to update Firebase user profile:", error_8);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    (0, react_1.useEffect)(function () {
        if (!isOpen) {
            return;
        }
        // Reset prefill flags when modal opens to ensure fresh data load
        hasPrefilledFromFirebaseRef.current = false;
        hasPrefilledFromProfileRef.current = false;
        var firebaseUid = resolveFirebaseUid();
        if (!firebaseUid) {
            console.warn("⚠️ No Firebase UID found when modal opened");
            return;
        }
        fetchAndSetFirebaseProfile(firebaseUid);
    }, [isOpen, user === null || user === void 0 ? void 0 : user.firebase_user_id, user === null || user === void 0 ? void 0 : user.user_id]);
    // Populate Firebase-profile-derived fields for returning users.
    // Runs once per modal open after firebaseUserProfile resolves from Redux.
    // applyMappedLoanData (if a DRAFT loan exists) runs AFTER this and overrides
    // with loan-specific values where present — see the documented order in
    // the modal-open useEffect above.
    (0, react_1.useEffect)(function () {
        var _a, _b, _c, _d;
        // Only populate when modal is open
        if (!isOpen) {
            return;
        }
        if (!firebaseUserProfile || hasPrefilledFromProfileRef.current) {
            return;
        }
        // If a DRAFT has already loaded, do not write profile values directly into
        // the form. Replaying applyMappedLoanData keeps the existing draft as the
        // user-entered source of truth while still using the refreshed profile as
        // the fallback for blank draft fields.
        if (remoteDraftLoadedRef.current &&
            loadedDraftForProfileReplayRef.current) {
            applyMappedLoanData(loadedDraftForProfileReplayRef.current);
            hasPrefilledFromProfileRef.current = true;
            return;
        }
        // Populate spouse data from profile
        if (firebaseUserProfile.spouse) {
            setSpouseName((_a = firebaseUserProfile.spouse.name) !== null && _a !== void 0 ? _a : "");
            setSpouseLastName((_b = firebaseUserProfile.spouse.surname) !== null && _b !== void 0 ? _b : "");
            var spouseCell = convertProfilePhoneToIPhone(firebaseUserProfile.spouse.cell_number);
            if (spouseCell) {
                setSpousePhoneNumber(normalizePhoneForState(spouseCell));
            }
            var spouseHome = convertProfilePhoneToIPhone(firebaseUserProfile.spouse.home_number);
            if (spouseHome) {
                setSpouseHomeNumber(normalizePhoneForState(spouseHome));
            }
            var spouseWork = convertProfilePhoneToIPhone(firebaseUserProfile.spouse.work_number);
            if (spouseWork) {
                setSpouseWorkNumber(normalizePhoneForState(spouseWork));
            }
        }
        // Populate Postal Address (top-level on user doc). Sky Lifestyle writes
        // this on every profile-touching flow, but the modal's useState
        // initialiser captures the value at mount — which fires before Redux
        // has resolved. Re-seed here once Redux is ready.
        // Truthy guard is intentional: modal initialises postal_address to ""
        // by default, so skipping on a missing profile value is correct.
        if (firebaseUserProfile.postal_address) {
            setPostalAddress(firebaseUserProfile.postal_address);
        }
        // Populate Employment Details from profile. Includes employment_status
        // and monthly_income — both written by Sky Lifestyle web on loan
        // completion (verified against real Firestore docs).
        if (firebaseUserProfile.employment_details) {
            var emp = firebaseUserProfile.employment_details;
            // Use ?? "" (not truthy guard) for employment_status and monthly_income
            // so an explicit empty value clears the field — consistent with the
            // applyMappedLoanData fallback and handleKYCComplete that use the same pattern.
            setEmploymentStatus((_c = emp.employment_status) !== null && _c !== void 0 ? _c : "");
            setMonthlyIncome((_d = emp.monthly_income) !== null && _d !== void 0 ? _d : "");
            if (emp.employer)
                setEmployer(emp.employer);
            if (emp.supervisor)
                setSupervisorName(emp.supervisor);
            if (emp.department)
                setDepartmentNumber(emp.department);
            if (emp.employee_number)
                setEmployeeNumber(emp.employee_number);
            if (emp.address)
                setWorkplaceAddress(emp.address);
            if (emp.appointment_date) {
                var date = emp.appointment_date;
                var dateStr = "";
                if (typeof date === "string") {
                    dateStr = date.split("T")[0];
                }
                else if (date instanceof Date) {
                    dateStr = date.toISOString().split("T")[0];
                }
                else if (typeof date === "object" && "toDate" in date) {
                    dateStr = date.toDate().toISOString().split("T")[0];
                }
                if (dateStr)
                    setAppointmentDate(dateStr);
            }
            var workPhone = convertProfilePhoneToIPhone(emp.work_number);
            if (workPhone) {
                var normalized = normalizePhoneForState(workPhone);
                setWorkNumber(normalized);
                setEmployeePhoneNumber(normalized);
            }
        }
        // Populate HR / Paypoint Details from profile. Sky Lifestyle stores
        // HR Name as paymaster_number and HR Phone as phone_number inside
        // paypoint_details (loan-data-mapper.ts:318-321 documents the mapping).
        if (firebaseUserProfile.paypoint_details) {
            var pp = firebaseUserProfile.paypoint_details;
            if (pp.paymaster_number)
                setHRName(pp.paymaster_number);
            var hrPhone = convertProfilePhoneToIPhone(pp.phone_number);
            if (hrPhone) {
                setHRPhoneNumber(normalizePhoneForState(hrPhone));
            }
            if (pp.physical_address)
                setPayPointPhysicalAddress(pp.physical_address);
            if (pp.postal_address)
                setPayPointPostalAddress(pp.postal_address);
            if (pp.postal_code)
                setPostalCode(pp.postal_code);
        }
        hasPrefilledFromProfileRef.current = true;
    }, [applyMappedLoanData, isOpen, firebaseUserProfile]);
    // Auto-save progress to Firebase as user progresses through steps
    var handleAutoSaveProgress = function (stepCompleted, overrides) { return __awaiter(void 0, void 0, void 0, function () {
        var payslipUrl, bankStmtUrls, formData_2, progressData, result, appId, partialProfileUpdate, cleanedPartial, profileSyncError_1, error_9;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 12, , 13]);
                    payslipUrl = (_a = overrides === null || overrides === void 0 ? void 0 : overrides.latestPayslipUrl) !== null && _a !== void 0 ? _a : latestPayslipUrl;
                    bankStmtUrls = (_b = overrides === null || overrides === void 0 ? void 0 : overrides.bankStatementsUrl) !== null && _b !== void 0 ? _b : bankStatementsUrl;
                    formData_2 = {
                        name: name,
                        surname: surname,
                        loanAmount: loanAmount,
                        loanTerm: loanTerm,
                        selectedBranch: selectedBranch,
                        homeAddress: homeAddress,
                        homeAddressGeoPoint: homeAddressGeoPoint,
                        postalAddress: postalAddress,
                        postalAddressGeoPoint: postalAddressGeoPoint,
                        idNumber: idNumber,
                        isMarried: isMarried,
                        spouseName: spouseName,
                        spouseLastName: spouseLastName,
                        spousePhoneNumber: spousePhoneNumber,
                        spouseHomeNumber: spouseHomeNumber,
                        spouseWorkNumber: spouseWorkNumber,
                        familyMemberName: familyMemberName,
                        familyMemberSurname: familyMemberSurname,
                        familyMemberRelationship: familyMemberRelationship,
                        familyMemberCellPhone: familyMemberCellPhone,
                        familyMemberWorkPhone: familyMemberWorkPhone,
                        familyMemberHomePhone: familyMemberHomePhone,
                        friendName: friendName,
                        friendSurname: friendSurname,
                        friendCellPhone: friendCellPhone,
                        friendWorkPhone: friendWorkPhone,
                        friendHomePhone: friendHomePhone,
                        employmentStatus: employmentStatus,
                        monthlyIncome: monthlyIncome,
                        employer: employer,
                        supervisorName: supervisorName,
                        departmentNumber: departmentNumber,
                        employeeNumber: employeeNumber,
                        workplaceAddress: workplaceAddress,
                        workplaceAddressGeoPoint: workplaceAddressGeoPoint,
                        workNumber: workNumber,
                        appointmentDate: appointmentDate,
                        housingExpense: housingExpense,
                        transportExpense: transportExpense,
                        educationExpense: educationExpense,
                        electricityExpense: electricityExpense,
                        groceriesExpense: groceriesExpense,
                        accountPayments: accountPayments,
                        fixedDeductions: fixedDeductions,
                        otherObligations: otherObligations,
                        payFrequency: payFrequency,
                        payDate: payDate,
                        paymasterName: paymasterName,
                        payPointPhoneNumber: payPointPhoneNumber,
                        payPointPostalAddress: payPointPostalAddress,
                        payPointPostalAddressGeoPoint: payPointPostalAddressGeoPoint,
                        payPointPhysicalAddress: payPointPhysicalAddress,
                        payPointPhysicalAddressGeoPoint: payPointPhysicalAddressGeoPoint,
                        postalCode: postalCode,
                        // HR fields — see save-side note in handleSubmitApplication; the
                        // mapper reads formData.hr*, but payPoint*/paymaster* state is what
                        // the modal carries. Alias here so autosave matches the mapper's
                        // contract.
                        hrName: hrName,
                        hrPhoneNumber: hrPhoneNumber,
                        hrPostalAddress: payPointPostalAddress,
                        hrPostalAddressGeoPoint: payPointPostalAddressGeoPoint,
                        hrPhysicalAddress: payPointPhysicalAddress,
                        hrPhysicalAddressGeoPoint: payPointPhysicalAddressGeoPoint,
                        selectedBank: selectedBank,
                        bankBranch: bankBranch,
                        accountNumber: accountNumber,
                        accountType: accountType,
                        signatureURL: signatureURL,
                        confirmationChecked: confirmationChecked,
                        // Document URLs (use overrides if provided for immediate uploads)
                        latest_payslip: payslipUrl,
                        bank_statements: bankStmtUrls,
                        status: loan_application_1.APPLICATION_STATUS.DRAFT,
                        // Set completion flags based on 12-step flow
                        kyc_complete: stepCompleted >= step_constants_1.STEP_KYC,
                        personal_complete: stepCompleted >= step_constants_1.STEP_PERSONAL_DETAILS,
                        family_complete: stepCompleted >= step_constants_1.STEP_FAMILY_CONTACTS,
                        friend_complete: stepCompleted >= step_constants_1.STEP_FAMILY_CONTACTS,
                        employment_complete: stepCompleted >= step_constants_1.STEP_EMPLOYMENT,
                        paypoint_complete: stepCompleted >= step_constants_1.STEP_HR_DETAILS,
                        bankDetails_complete: stepCompleted >= step_constants_1.STEP_SALARY_BANKING,
                        financial_complete: stepCompleted >= step_constants_1.STEP_FINANCIAL_DETAILS,
                        docs_complete: stepCompleted >= step_constants_1.STEP_DOCUMENTS &&
                            (Boolean(payslipUrl) || bankStmtUrls.length > 0),
                        authoriseSalary_complete: stepCompleted >= step_constants_1.STEP_AUTHORIZATION_SALARY,
                        authoriseBank_complete: stepCompleted >= step_constants_1.STEP_AUTHORIZATION_ELECTRONIC,
                        // Add user and provider references
                        // Always use Firebase localId for Firebase loan creation
                        userId: user === null || user === void 0 ? void 0 : user.firebase_user_id,
                        providerId: selectedProviderId, // Use selected provider ID from form
                    };
                    progressData = (0, loan_data_mapper_1.mapFormDataToSkyLifestyle)(formData_2);
                    result = void 0;
                    appId = currentApplicationIdRef.current;
                    if (!appId) return [3 /*break*/, 2];
                    return [4 /*yield*/, (0, application_1.updateLoanApplication)(__assign({ uid: appId }, progressData))];
                case 1:
                    // Update existing application
                    result = _d.sent();
                    return [3 /*break*/, 4];
                case 2: return [4 /*yield*/, (0, application_1.createLoanApplication)(progressData)];
                case 3:
                    // Create new application
                    result = _d.sent();
                    if (result.success && ((_c = result.content) === null || _c === void 0 ? void 0 : _c.uid)) {
                        setCurrentApplicationId(result.content.uid);
                        currentApplicationIdRef.current = result.content.uid;
                    }
                    _d.label = 4;
                case 4:
                    if (!result.success) return [3 /*break*/, 11];
                    _d.label = 5;
                case 5:
                    _d.trys.push([5, 8, , 9]);
                    partialProfileUpdate = buildProfileUpdatePayload();
                    cleanedPartial = JSON.parse(JSON.stringify(partialProfileUpdate, function (key, value) {
                        // Remove undefined and null values
                        if (value === undefined || value === null)
                            return undefined;
                        // Remove empty objects
                        if (typeof value === "object" &&
                            !Array.isArray(value) &&
                            Object.keys(value).length === 0)
                            return undefined;
                        return value;
                    }));
                    if (!(Object.keys(cleanedPartial).length > 0)) return [3 /*break*/, 7];
                    return [4 /*yield*/, updateProfile(cleanedPartial).unwrap()];
                case 6:
                    _d.sent();
                    _d.label = 7;
                case 7: return [3 /*break*/, 9];
                case 8:
                    profileSyncError_1 = _d.sent();
                    console.error("Auto-save profile sync error (non-blocking):", profileSyncError_1);
                    return [3 /*break*/, 9];
                case 9: return [4 /*yield*/, pushFirebaseUserUpdate()];
                case 10:
                    _d.sent();
                    _d.label = 11;
                case 11: return [3 /*break*/, 13];
                case 12:
                    error_9 = _d.sent();
                    console.error("Error auto-saving progress:", error_9);
                    return [3 /*break*/, 13];
                case 13: return [2 /*return*/];
            }
        });
    }); };
    var getDisplayValue = function (value, defaultText) {
        if (defaultText === void 0) { defaultText = "Not provided"; }
        if (value === null || value === undefined || value === "")
            return defaultText;
        if (typeof value === "boolean")
            return value ? "Yes" : "No";
        return value;
    };
    var formatPhoneNumber = function (phone) {
        if (!phone.phone_number)
            return "Not provided";
        return "".concat(phone.country_code, " ").concat(phone.phone_number);
    };
    var getLoanTermLabel = function (term) {
        var termOption = LOAN_TERMS.find(function (t) { return t.value === term; });
        return termOption ? termOption.label : term;
    };
    var getBankLabel = function (bank) {
        var bankOption = BANKS.find(function (b) { return b.value === bank; });
        return bankOption ? bankOption.label : bank;
    };
    var getAccountTypeLabel = function (type) {
        var typeOption = ACCOUNT_TYPES.find(function (t) { return t.value === type; });
        return typeOption ? typeOption.label : type;
    };
    var getBranchLabel = function (branch) {
        var branchOption = branches.find(function (b) { return b.value === branch; });
        return branchOption ? branchOption.label : branch;
    };
    var handleLocationClick = function (field) {
        // TODO: Implement location selection modal/functionality
    };
    var handleDocumentUpload = function (docNumber, event) {
        var files = event.target.files;
        if (files) {
            if (docNumber === 1) {
                // Single payslip file
                setSalaryBankingDoc1(files[0]);
            }
            else {
                // Multiple bank statement files
                var fileArray_1 = Array.from(files);
                setSalaryBankingDoc2(function (prev) { return __spreadArray(__spreadArray([], prev, true), fileArray_1, true); });
            }
            // Clear document error if file is selected
            if (errors.documents) {
                var newErrors = __assign({}, errors);
                delete newErrors.documents;
                setErrors(newErrors);
            }
        }
    };
    var handleRemoveBankStatement = function (index) {
        setSalaryBankingDoc2(function (prev) { return prev.filter(function (_, i) { return i !== index; }); });
    };
    if (!isOpen)
        return null;
    // Check if user is authenticated before showing loan application
    if (!(user === null || user === void 0 ? void 0 : user.firebase_user_id)) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50", children: (0, jsx_runtime_1.jsx)("div", { className: "bg-white rounded-2xl p-8 max-w-md mx-4 shadow-2xl", children: (0, jsx_runtime_1.jsxs)("div", { className: "text-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4", children: (0, jsx_runtime_1.jsx)("svg", { className: "w-8 h-8 text-red-600", fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: (0, jsx_runtime_1.jsx)("path", { strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 2, d: "M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" }) }) }), (0, jsx_runtime_1.jsx)("h2", { className: "text-2xl font-bold text-gray-900 mb-3", children: "Login Required" }), (0, jsx_runtime_1.jsx)("p", { className: "text-gray-600 mb-6", children: "You must be logged in to apply for a loan. Please log in or create an account to continue." }), (0, jsx_runtime_1.jsx)("button", { onClick: onClose, className: "w-full bg-gradient-to-r from-purple-600 to-purple-700 text-white font-semibold py-3 px-6 rounded-xl hover:from-purple-700 hover:to-purple-800 transition-all duration-200 shadow-lg", children: "Close" })] }) }) }));
    }
    var resetForm = function () {
        // Reset all step states
        setCurrentStep(step_constants_1.STEP_KYC); // Start with Personal step, skip KYC
        // Reset KYC state
        setKycCompleted(false);
        setKycError(null);
        // Reset Step 1: Personal Information
        setName("");
        setSurname("");
        setIdNumber("");
        setHomeAddress(null);
        setPostalAddress("");
        setGender("");
        setIsMarried(false);
        setMarriageType("");
        setNextOfKin(null);
        setSpouseName("");
        setSpouseLastName("");
        setSpousePhoneNumber({
            phone_number: "",
            country_code: "+264",
            country_abbreviation: "NA",
        });
        setSpouseWorkNumber({
            phone_number: "",
            country_code: "+264",
            country_abbreviation: "NA",
        });
        // Reset Family Members and Friend Contact Details
        setFamilyMemberName("");
        setFamilyMemberSurname("");
        setFamilyMemberRelationship("");
        setFamilyMemberCellPhone({
            phone_number: "",
            country_code: "+264",
            country_abbreviation: "NA",
        });
        setFamilyMemberWorkPhone({
            phone_number: "",
            country_code: "+264",
            country_abbreviation: "NA",
        });
        setFamilyMemberHomePhone({
            phone_number: "",
            country_code: "+264",
            country_abbreviation: "NA",
        });
        setFriendName("");
        setFriendSurname("");
        setFriendCellPhone({
            phone_number: "",
            country_code: "+264",
            country_abbreviation: "NA",
        });
        setFriendWorkPhone({
            phone_number: "",
            country_code: "+264",
            country_abbreviation: "NA",
        });
        setFriendHomePhone({
            phone_number: "",
            country_code: "+264",
            country_abbreviation: "NA",
        });
        // Reset Step 2: Loan Amount & Employment
        setSelectedBranch("");
        setLoanTerm("");
        setLoanAmount(LOAN_AMOUNT_LIMITS.DEFAULT.toFixed(2)); // Client update: reuse configured default loan amount when resetting.
        setEmploymentStatus("");
        setMonthlyIncome("");
        setEmployer("");
        setSupervisorName("");
        setWorkNumber({
            phone_number: "",
            country_code: "+264",
            country_abbreviation: "NA",
        });
        setDepartmentNumber("");
        setWorkplaceAddress("");
        setWorkplaceAddressGeoPoint(null);
        setEmployeeNumber("");
        setAppointmentDate("");
        setPayFrequency("");
        setPayDate("");
        setEmployeeName("");
        setEmployeeSurname("");
        setEmployeeIdNumber("");
        setEmployeePhoneNumber({
            phone_number: "",
            country_code: "+264",
            country_abbreviation: "NA",
        }); // Client update: reset employee phone so it can repopulate from user data.
        setForceNumber("");
        setLender("");
        setYourEmployer("");
        setHasEditedYourEmployer(false); // Client update: ensure sync can run after reset.
        // Reset HR/Paypoint details
        setPaymasterName("");
        setPayPointPhoneNumber({
            phone_number: "",
            country_code: "+264",
            country_abbreviation: "NA",
        });
        setHRPhoneNumber({
            phone_number: "",
            country_code: "+264",
            country_abbreviation: "NA",
        });
        setHRName("");
        setPayPointPostalAddress("");
        setPayPointPostalAddressGeoPoint(null);
        setPostalCode("");
        setPayPointPhysicalAddress("");
        setPayPointPhysicalAddressGeoPoint(null);
        // Reset Banking details
        setSelectedBank("");
        setBankBranch("");
        setAccountNumber("");
        setAccountType("");
        // Reset Document uploads - CRITICAL: Clear cached documents for new applications
        setSalaryBankingDoc1(null);
        setSalaryBankingDoc2([]);
        setLatestPayslipUrl("");
        setBankStatementsUrl([]);
        // Reset Affordability lists with zero defaults
        setHousingExpense("0.00");
        setTransportExpense("0.00");
        setEducationExpense("0.00");
        setElectricityExpense("0.00");
        setGroceriesExpense("0.00");
        setAccountPayments([
            { id: Date.now().toString(), description: "Clothing", amount: "0.00" },
        ]);
        setFixedDeductions([
            {
                id: Date.now().toString(),
                description: "Debit Orders etc..",
                amount: "0.00",
            },
        ]);
        setOtherObligations([
            { id: Date.now().toString(), description: "Food", amount: "0.00" },
        ]);
        // Reset Step 5: Review
        setConfirmationChecked(false);
        // Reset signature states
        setSignatureURL("");
        setSignedDocumentUrl("");
        setSignatureError("");
        setBankSignatureURL("");
        setBankSignatureError("");
        // Reset completion and application tracking
        setShowCompletionModal(false);
        setCurrentApplicationId(null);
        currentApplicationIdRef.current = null;
        setIsSubmitting(false);
    };
    var handleCompletionClose = function () {
        resetForm(); // Reset all form data
        onClose(); // Close the main modal too
    };
    var requiresSalaryDeductionSignature = employmentRequiresSalaryDeduction(employmentStatus);
    var hasSavedSalarySignature = Boolean(signatureURL); // Step 9 signature
    var hasSavedBankSignature = Boolean(bankSignatureURL); // Step 10 signature
    var isAgreementsStep = currentStep === STEP_AGREEMENTS;
    var isBankingDocumentsStep = currentStep === STEP_BANKING_DOCUMENTS;
    var isSalaryDeductionAuthStep = currentStep === step_constants_1.STEP_AUTHORIZATION_SALARY;
    var isElectronicPaymentsAuthStep = currentStep === step_constants_1.STEP_AUTHORIZATION_ELECTRONIC;
    var agreementsRequirementsMet = !isAgreementsStep ||
        (hasSavedBankSignature &&
            (!requiresSalaryDeductionSignature || hasSavedSalarySignature));
    // For Documents step: check if at least one document is uploaded (file or URL)
    var hasDocumentsUploaded = Boolean(salaryBankingDoc1 ||
        (salaryBankingDoc2 && salaryBankingDoc2.length > 0) ||
        latestPayslipUrl ||
        (bankStatementsUrl && bankStatementsUrl.length > 0));
    var documentsRequirementsMet = !isBankingDocumentsStep || hasDocumentsUploaded;
    // For Step 9 (Salary Deduction Authorization): check if signature is saved
    var salaryDeductionAuthRequirementsMet = !isSalaryDeductionAuthStep || Boolean(signatureURL);
    // For Step 10 (Electronic Payments Authorization): check if signature is saved
    var electronicPaymentsAuthRequirementsMet = !isElectronicPaymentsAuthStep || Boolean(bankSignatureURL);
    var isPrimaryActionDisabled = isSubmitting ||
        !agreementsRequirementsMet ||
        !documentsRequirementsMet ||
        !salaryDeductionAuthRequirementsMet ||
        !electronicPaymentsAuthRequirementsMet;
    var canNavigateBack = currentStep > step_constants_1.STEP_START;
    // Form data object for step renderer
    var formData = {
        // Personal info (name/surname mapped to firstName/lastName for step renderer)
        firstName: name,
        lastName: surname,
        idNumber: idNumber,
        gender: gender,
        homeAddress: typeof homeAddress === "string"
            ? homeAddress
            : (homeAddress === null || homeAddress === void 0 ? void 0 : homeAddress.full_address) || "",
        homeAddressGeoPoint: homeAddressGeoPoint,
        postalAddress: postalAddress,
        postalAddressGeoPoint: postalAddressGeoPoint,
        isMarried: isMarried,
        marriageType: marriageType || "",
        // Spouse details
        spouseFirstName: spouseName,
        spouseLastName: spouseLastName,
        spousePhoneNumber: spousePhoneNumber,
        spouseHomeNumber: spouseHomeNumber,
        spouseWorkNumber: spouseWorkNumber,
        // Family member
        familyMemberName: familyMemberName,
        familyMemberSurname: familyMemberSurname,
        familyMemberRelationship: familyMemberRelationship,
        familyMemberCellPhone: familyMemberCellPhone,
        familyMemberWorkPhone: familyMemberWorkPhone,
        familyMemberHomePhone: familyMemberHomePhone,
        // Friend
        friendName: friendName,
        friendSurname: friendSurname,
        friendCellPhone: friendCellPhone,
        friendWorkPhone: friendWorkPhone,
        friendHomePhone: friendHomePhone,
        // Loan details
        loanAmount: loanAmount,
        loanTerm: loanTerm,
        selectedProviderId: selectedProviderId,
        selectedBranch: selectedBranch,
        loanAmountLimits: LOAN_AMOUNT_LIMITS,
        loanTermOptions: LOAN_TERMS,
        // Employment
        employmentStatus: employmentStatus,
        monthlyIncome: monthlyIncome,
        employer: employer,
        supervisorName: supervisorName,
        workNumber: workNumber,
        departmentNumber: departmentNumber,
        employeeNumber: employeeNumber,
        workplaceAddress: workplaceAddress,
        workplaceAddressGeoPoint: workplaceAddressGeoPoint,
        appointmentDate: appointmentDate,
        // HR/Paymaster
        paymasterName: paymasterName,
        paymasterPhoneNumber: payPointPhoneNumber,
        hrName: hrName,
        hrPhoneNumber: hrPhoneNumber,
        hrPostalAddress: payPointPostalAddress,
        hrPostalAddressGeoPoint: payPointPostalAddressGeoPoint,
        hrPostalCode: postalCode,
        hrPhysicalAddress: payPointPhysicalAddress,
        hrPhysicalAddressGeoPoint: payPointPhysicalAddressGeoPoint,
        // Banking
        bank: selectedBank,
        branch: bankBranch,
        accountNumber: accountNumber,
        accountType: accountType,
        // Financial
        payFrequency: payFrequency,
        payDate: payDate,
        housingExpense: housingExpense,
        transportExpense: transportExpense,
        educationExpense: educationExpense,
        electricityExpense: electricityExpense,
        groceriesExpense: groceriesExpense,
        accountPayments: accountPayments,
        fixedDeductions: fixedDeductions,
        otherObligations: otherObligations,
        // Documents
        payslipFile: salaryBankingDoc1,
        payslipURL: "", // TODO: Add state for uploaded URL
        bankStatementFiles: salaryBankingDoc2,
        bankStatementURLs: [], // TODO: Add state for uploaded URLs
        // Signatures
        salaryDeductionSignatureURL: signatureURL,
        electronicPaymentsSignatureURL: bankSignatureURL,
        forceNumber: forceNumber,
        // Errors
        errors: errors,
    };
    // Show completion modal if submission is successful
    if (showCompletionModal) {
        return ((0, jsx_runtime_1.jsx)(loan_application_completed_1.LoanApplicationCompleted, { isOpen: showCompletionModal, onClose: handleCompletionClose, branding: branding }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { className: "fixed inset-0 z-50 overflow-y-auto", children: [(0, jsx_runtime_1.jsx)("div", { className: "fixed inset-0 bg-black/50", onClick: onClose }), (0, jsx_runtime_1.jsx)("div", { className: "relative min-h-screen flex items-center justify-center p-4", children: (0, jsx_runtime_1.jsxs)("div", { className: "relative bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh]", children: [(0, jsx_runtime_1.jsx)("button", { onClick: onClose, className: "absolute top-4 right-4 w-8 h-8 rounded-full flex items-center justify-center text-gray-500 hover:text-gray-700 hover:bg-gray-100 z-10", children: "\u00D7" }), (0, jsx_runtime_1.jsxs)("div", { className: "px-8 pt-8 pb-6 border-b border-gray-200", children: [(0, jsx_runtime_1.jsx)("h2", { className: "text-2xl font-bold text-gray-900 text-center mb-6", children: "Loan Application" }), (0, jsx_runtime_1.jsx)("div", { className: "flex justify-center items-center max-w-3xl mx-auto", children: (function () {
                                        var MAX_VISIBLE = 5;
                                        var totalSteps = step_constants_1.STEPS.length;
                                        var currentIndex = step_constants_1.STEPS.findIndex(function (s) { return s.id === currentStep; });
                                        var visibleSteps = [];
                                        var showLeftDots = false;
                                        var showRightDots = false;
                                        if (totalSteps <= MAX_VISIBLE) {
                                            // Show all steps if total is 5 or less
                                            visibleSteps = step_constants_1.STEPS;
                                        }
                                        else {
                                            // Calculate which steps to show
                                            if (currentIndex < 3) {
                                                // Near start: show first 5
                                                visibleSteps = step_constants_1.STEPS.slice(0, MAX_VISIBLE);
                                                showRightDots = true;
                                            }
                                            else if (currentIndex >= totalSteps - 3) {
                                                // Near end: show last 5
                                                visibleSteps = step_constants_1.STEPS.slice(-MAX_VISIBLE);
                                                showLeftDots = true;
                                            }
                                            else {
                                                // Middle: show current step centered with 2 on each side
                                                visibleSteps = step_constants_1.STEPS.slice(currentIndex - 2, currentIndex + 3);
                                                showLeftDots = true;
                                                showRightDots = true;
                                            }
                                        }
                                        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [showLeftDots && ((0, jsx_runtime_1.jsx)("div", { className: "flex items-center mx-2", children: (0, jsx_runtime_1.jsx)("span", { className: "text-gray-400 text-2xl font-bold leading-none", children: "\u2022\u2022\u2022" }) })), visibleSteps.map(function (step, index) { return ((0, jsx_runtime_1.jsxs)(react_1.default.Fragment, { children: [(index > 0 || showLeftDots) && ((0, jsx_runtime_1.jsx)("div", { className: "h-0.5 ".concat(currentStep > step.id
                                                                ? "bg-green-500"
                                                                : "bg-gray-200"), style: { width: "40px" } })), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-center", children: [(0, jsx_runtime_1.jsx)("div", { className: "w-10 h-10 rounded-full flex items-center justify-center text-sm font-semibold\n                              ".concat(currentStep === step.id
                                                                        ? "text-white"
                                                                        : currentStep > step.id
                                                                            ? "bg-green-500 text-white"
                                                                            : "bg-gray-200 text-gray-500"), style: {
                                                                        backgroundColor: currentStep === step.id
                                                                            ? branding.primaryColor
                                                                            : undefined,
                                                                    }, children: currentStep > step.id ? "✓" : step.id }), (0, jsx_runtime_1.jsx)("span", { className: "text-xs mt-2 text-center whitespace-pre-line max-w-[70px]", children: step.label })] })] }, step.id)); }), showRightDots && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { className: "h-0.5 bg-gray-200", style: { width: "40px" } }), (0, jsx_runtime_1.jsx)("div", { className: "flex items-center mx-2", children: (0, jsx_runtime_1.jsx)("span", { className: "text-gray-400 text-2xl font-bold leading-none", children: "\u2022\u2022\u2022" }) })] }))] }));
                                    })() })] }), (0, jsx_runtime_1.jsx)("div", { className: "px-8 py-6 overflow-y-auto", style: { maxHeight: "calc(90vh - 240px)" }, "data-modal-content": true, children: (0, loan_application_step_renderer_1.renderLoanApplicationStep)({
                                currentStep: currentStep,
                                kycCompleted: kycCompleted,
                                formData: formData,
                                onUpdate: handleFormDataUpdate,
                                onNext: function (nextStep) { return setCurrentStep(nextStep); },
                                onBack: function (prevStep) { return setCurrentStep(prevStep); },
                                isManualNavigation: isManualNavigationRef.current, // Pass manual navigation flag
                                branding: branding,
                                user: user,
                                firebaseUserProfile: firebaseUserProfile,
                                isSubmitting: isSubmitting,
                                isCheckingDraft: isCheckingDraft,
                                provider: provider,
                                branches: branches,
                                loadingProviders: loadingProviders,
                                loadingBranches: loadingBranches,
                                formatCurrency: function (amount) {
                                    return (0, currency_1.formatCurrencyDisplay)(amount, currency);
                                },
                                isGoogleMapsLoaded: isGoogleMapsLoaded,
                                handleKYCComplete: handleKYCComplete,
                                handleKYCError: handleKYCError,
                            }) }), currentStep !== step_constants_1.STEP_COMPLETE && ((0, jsx_runtime_1.jsxs)("div", { className: "px-8 py-4 border-t border-gray-200 flex justify-between items-center bg-white", children: [canNavigateBack ? ((0, jsx_runtime_1.jsx)("button", { type: "button", onClick: handleBack, className: "px-4 py-2 bg-gray-100 text-gray-700 rounded-lg hover:opacity-90 text-sm", children: "Back" })) : ((0, jsx_runtime_1.jsx)("div", {})), (0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col items-end gap-2", children: [validationMessage && ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center gap-2 px-4 py-2 bg-red-50 border border-red-200 rounded-lg text-sm text-red-700", children: [(0, jsx_runtime_1.jsx)("svg", { className: "w-5 h-5 flex-shrink-0", fill: "currentColor", viewBox: "0 0 20 20", children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", d: "M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z", clipRule: "evenodd" }) }), (0, jsx_runtime_1.jsx)("span", { className: "font-medium", children: validationMessage })] })), (0, jsx_runtime_1.jsx)("div", { className: "flex justify-end gap-2", children: (0, jsx_runtime_1.jsx)("button", { type: "button", onClick: handleContinue, disabled: isPrimaryActionDisabled, className: "px-4 py-2 text-white rounded-lg hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed text-sm", style: { backgroundColor: branding.primaryColor }, children: currentStep === STEP_AGREEMENTS
                                                    ? isSubmitting
                                                        ? "Submitting..."
                                                        : "Submit Application"
                                                    : "Continue" }) })] })] }))] }) })] }));
};
exports.LoanApplicationModal = LoanApplicationModal;
